// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:20.665Z
// Property: Wade Crossing Apartment Homes (ID: 6767906449167621)
// Collections: 27 amenities, 6 floorplans (live), 63 photos, 80 POIs, 4 reviews, 2 virtual tours, 6 office hours, 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167621",
  "property_external_id": "1105360",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/wade-crossing-apartment-homes-frisco-tx/hzzbye0/",
  "property_google_business_url": "https://www.google.com/maps/place/Wade+Crossing+Apartment+Homes/@33.1283619,-96.7991743,958m/data=!3m2!1e3!4b1!4m6!3m5!1s0x864c3c502f7f1a01:0x7a08caf590359945!8m2!3d33.1283619!4d-96.7991743!16s%2Fg%2F1tfhz_c8?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1105360 p1080371",
  "property_status": null,
  "property_slug": "wade-crossing-apartment-homes",
  "property_name": "Wade Crossing Apartment Homes",
  "property_website_url": "https://www.wadecrossingapts.com/",
  "property_domain": "https://www.wadecrossingapts.com/",
  "property_address": "9399 Wade Blvd",
  "property_full_address": "9399 Wade Blvd, Frisco, TX 75035",
  "property_address_1": "9399 Wade Blvd",
  "property_address_2": null,
  "property_address_city": "Frisco",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "75035",
  "property_address_country": "US",
  "property_address_county": "Collin County",
  "property_neighborhood_address": "Frisco",
  "property_address_latitude": "33.1288967",
  "property_address_longitude": "-96.79757389999999",
  "property_email": "RentCafe.WA@PriceKC.com",
  "property_phone": "(972) 707-2196",
  "property_call_tracking_phone": "972-707-2196",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Live close to Frisco’s everyday energy at Wade Crossing Apartment Homes.</strong> Explore one, two, and three bedroom <a href=\"/floor-plans\">floor plans</a> with inviting finishes, relaxed community spaces, and easy access to the places that make the area feel connected—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see it all in person.</p>",
  "property_long_description": "<p>Wade Crossing Apartment Homes is a gated, pet-friendly apartment community at 9399 Wade Blvd in Frisco, TX 75035, offering one-, two-, and three-bedroom apartments. The community is managed by Price Brothers Management, a family-owned company that has been managing apartment homes since 1922.</p><p>Every apartment at Wade Crossing has an open-concept layout, a fully equipped kitchen, spacious closets, and a private balcony, so there’s room to relax after a long day.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-4c05-75ed-bcea-4d93bf95a955.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with white cabinets, appliances, and granite countertops.",
    "public_id": "01a0b673-4c05-75ed-bcea-4d93bf95a955",
    "storage_key": "property/6767906449167621/01a0b673-4c05-75ed-bcea-4d93bf95a955.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "336",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.15476190476191",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://wadecrossingapts.securecafeapplicant.com/onlineleasing/content3/access/wade-crossing-apartments0/floorplans",
  "property_resident_portal_url": "https://wadecrossingapts.securecafe.com/residentservices/wade-crossing-apartments0/userlogin.aspx",
  "property_apply_now_url": "https://wadecrossingapts.securecafeapplicant.com/onlineleasing/content3/access/wade-crossing-apartments0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc98d-d129-760a-8283-c76e16c9be82.webp",
  "property_primary_logo_media": {
    "alt_text": "Wade Crossing Apartment Homes logo",
    "public_id": "019fc98d-d129-760a-8283-c76e16c9be82",
    "storage_key": "property/6767906449167621/019fc98d-d129-760a-8283-c76e16c9be82.webp",
    "width": 545,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a18ea7-0033-71e3-b925-6f07a36f9ee3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Wade Crossing Apartment Homes logo",
    "public_id": "01a18ea7-0033-71e3-b925-6f07a36f9ee3",
    "storage_key": "property/6767906449167621/01a18ea7-0033-71e3-b925-6f07a36f9ee3.webp",
    "width": 3072,
    "height": 846
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-4cae-732e-b5d9-7ec36fb2196a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019ff6a3-4cae-732e-b5d9-7ec36fb2196a",
    "storage_key": "property/6767906449167621/019ff6a3-4cae-732e-b5d9-7ec36fb2196a.webp",
    "width": 545,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#D19000",
  "property_secondary_color": "#1B365D",
  "property_font_color": null,
  "property_color_4": "#DCEDFF",
  "property_color_3": "#2C5697",
  "property_color_5": "#FCFAFA",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "707 - 1262",
  "property_sqft_min": "707",
  "property_sqft_max": "1262",
  "property_price_range": "919 - 5708",
  "property_price_min": "919",
  "property_price_max": "5708",
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/WadeCrossingApts",
  "property_instagram_url": "https://www.instagram.com/wadecrossingapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJARp_L1A8TIYRRZk1kPXKCHo",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Wade Crossing Apartment Homes",
  "property_home_romance_title": "Experience the Joy of Living in Your Perfect Home",
  "property_home_amenities_blurb": "<p>Wade Crossing residents have two swimming pools, a 24-hour fitness center, a basketball court, and a clubhouse with a kitchen, billiards, and WiFi. Detached garages are also available for extra parking and storage. <a href=\"/amenities\">See all amenities</a>.</p>",
  "property_home_floorplans_blurb": "<p>Wade Crossing offers six floor plans ranging from 707 to 1,262 square feet. Select homes add a wood-burning fireplace, a den or study, vinyl plank flooring, granite countertops, or full-size washer and dryer connections. <a href=\"/floor-plans\">Browse floor plans</a> to compare layouts and availability.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at Wade Crossing.</strong> Explore polished kitchens, spacious closets, ceiling fans, and select touches like wood-burning fireplaces, built-in bookshelves, balconies, or patios. Then picture the community beyond your front door, from the billiards clubhouse and fitness center to sunny poolside seating, grills, cabanas, and outdoor spaces made for unwinding.</p>",
  "property_home_neighborhood_blurb": "<p>Wade Crossing sits on Wade Blvd near Collin College’s Preston Ridge Campus, with the Dallas North Tollway close by for commutes across Dallas-Fort Worth. Downtown Frisco and Baylor Scott &amp; White Medical Center are a short drive away. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Wade Crossing feels easy to love.</strong> Reviews often highlight the friendly office team, attentive management, and prompt, professional maintenance. Add in quiet surroundings, well-kept grounds, cozy apartments, and community favorites like pools, a fitness center, and a basketball court, and the praise is easy to understand. See why residents call this Frisco community a good place to call home.</p>",
  "property_neighborhood_blurb": "<p>Wade Crossing Apartment Homes is an apartment community in Frisco, TX, just minutes from Toyota Stadium, home of FC Dallas. Residents live close to Frisco’s sports venues, shopping centers, and parks, with quick access to the Dallas North Tollway for commutes across Dallas-Fort Worth.</p><p>Wade Crossing is served by Frisco ISD, one of the most recognized school districts in North Texas, and Collin College’s Preston Ridge Campus is right down Wade Blvd.</p><p>For game days and nights out, Toyota Stadium, The Star in Frisco, and Downtown Frisco’s restaurants and local shops are all close by. Stonebriar Centre is the nearest major mall for shopping and dining, and Arbor Hills Nature Preserve has hiking and biking trails for time outdoors.</p><p>Looking for a place to eat near Wade Crossing? Our team recommends Coffee U for your morning coffee, Little Bit Bakery for a sweet treat, Luigi’s Pizza for a casual dinner, and Little Greek Fresh Grill for a quick, fresh lunch.</p><p>Baylor Scott &amp; White Medical Center and other major Frisco employers are a short drive from Wade Crossing. <a href=\"/floor-plans\">Explore our floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Wade Crossing Apartment Homes brings resort-style amenities to Frisco, TX, including two swimming pools, a 24-hour fitness center, a basketball court, and a clubhouse with billiards and WiFi. The community is gated, and residents also have a business center, a BBQ and picnic area, and an on-site laundry facility.</p><p>Looking for Frisco apartments with a garage? Wade Crossing offers detached garages for extra parking and storage.</p><p>Every apartment includes a fully equipped kitchen with a microwave and disposal, spacious closets, a ceiling fan, air conditioning, and a private balcony. Select homes add a wood-burning fireplace, granite countertops, vinyl plank flooring, a den or study, or full-size washer and dryer connections.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Wade Crossing home?</strong> Choose a one, two, or three bedroom layout with comfortable finishes and everyday conveniences in a relaxed Frisco community. Review available <a href=\"/floor-plans\">floor plans</a>, then start your online application when you’re ready.</p>",
  "property_contactus_blurb": "<p>Have questions? We’d love to hear from you!</p><p>Whether you’re interested in floor plans, apartment availability, pricing, or community amenities, the Wade Crossing Apartment Homes leasing team is here to help. Give us a call, send us a message, or stop by our leasing office in Frisco, TX. We look forward to helping you find a place to call home.</p><p>Already a resident? Visit our Resident Portal to make a payment or submit a maintenance request.</p>",
  "property_faqs_blurb": "<p>Have questions about life at Wade Crossing Apartment Homes? We’ve got answers! Explore our frequently asked questions to learn more about apartment availability, leasing, pet policies, community amenities, and what to expect when making your move to our Frisco, TX apartments. Still need a little help? Our leasing team is just a call or message away.</p>",
  "property_floorplans_blurb": "<p>Wade Crossing Apartment Homes offers six one-, two-, and three-bedroom floor plans in Frisco, TX, ranging from 707 to 1,262 square feet. Every floor plan has an open-concept living area, a fully equipped kitchen, spacious closets, and a private balcony.</p><p>Want more space or upgraded finishes? Select apartments at Wade Crossing include a wood-burning fireplace, a den or study, vinyl plank flooring, granite countertops, or full-size washer and dryer connections.</p><p>Compare pricing and current availability above, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plans in person.</p>",
  "property_gallery_blurb": "<p>Take a closer look at life at Wade Crossing Apartment Homes.</p><p>From spacious apartment interiors to inviting community amenities, our photo gallery gives you a glimpse of what makes our Frisco apartments feel like home. Picture yourself relaxing on your private balcony, spending sunny afternoons by one of our two swimming pools, or fitting in a workout at the 24-hour fitness center.</p><p>Explore our apartment features, community spaces, and landscaped grounds, then schedule a tour to experience Wade Crossing for yourself. Your next home might be just a few clicks away!</p>",
  "property_interactivemap_blurb": "<p>Finding your next apartment just got easier! Explore Wade Crossing Apartment Homes with our interactive property map and discover available apartments in Frisco, TX. Browse the community, compare apartment locations, and find the floor plan, features, and views that match what you’re looking for.</p><p>Filter available homes by bedrooms, bathrooms, pricing, square footage, and move-in date to narrow down your options. Once you’ve found your favorite, review the details, apply online, or schedule a tour to see it in person. Your next home is waiting!</p>",
  "property_pets_blurb": "<p>Wade Crossing Apartment Homes offers pet-friendly apartments in Frisco, TX, and welcomes both dogs and cats. Each apartment can have up to two pets, and the landscaped grounds give you room for daily walks.</p><p>Have questions about whether your pet qualifies? The Wade Crossing leasing team can walk you through the pet policy before you apply.</p><h2>Pet Policy</h2><ul><li>Non-refundable pet fee: $300 for one pet. $500 for two pets.</li><li>Pet rent: $25 per month, per pet</li><li>Maximum 2 pets per apartment home</li><li>Breed restrictions: Certain breeds are restricted, including Pit Bulls, Rottweilers, German Shepherds, and mixed breeds of these. Please contact the leasing office with any questions about your pet before you apply.</li></ul>",
  "property_referafriend_blurb": "<p><strong>Share Wade Crossing with a friend.</strong> If you love the relaxed community feel, two sparkling pools, 24-hour fitness center, and easy access to Frisco dining, shopping, sports, and green space, invite a friend to experience it too. Send a referral and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Wade Crossing.</strong><br>Keep your Frisco routine running smoothly—log in to pay rent, submit maintenance requests, and manage your account from one convenient place.</p>",
  "property_reviews_blurb": "<p><strong>Real reviews, real reasons to feel at home.</strong> As you explore feedback for Wade Crossing Apartment Homes, you’ll see recurring praise for the people behind the community—friendly office team, attentive management, and maintenance that residents describe as prompt, professional, and trustworthy. Longtime reviewers often point to the same comforts: a quiet setting, well-kept grounds, a welcoming sense of community, and a Frisco location that keeps daily needs close.</p><p>Residents also call out the value they find here, from cozy, well-maintained apartments to community spaces like the pools, fitness center, and basketball court. One reviewer summed it up simply: “If you are looking for a good place to call home start here!” Read the reviews below to see what living at Wade Crossing feels like from the people who know it firsthand.</p>",
  "property_created_at": "1785792869067",
  "property_scheduletour_blurb": "<p>Ready to see Wade Crossing Apartment Homes for yourself? We’d love to show you around! Schedule a tour of our apartments in Frisco, TX, and explore the spaces, features, and amenities that make our community a place to call home.</p><p>Walk through available floor plans, take a closer look at our two swimming pools, fitness center, and clubhouse, and get answers to your questions from our leasing team. Prefer to explore from home? Our interactive virtual tours make it easy to get started whenever it’s convenient for you.</p><p>Find a time that works for you and take the next step toward your new home at Wade Crossing!</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture everyday Frisco convenience with relaxed community spaces, two sparkling pools, a 24-hour fitness center, and thoughtfully finished one, two, and three bedroom apartment homes at Wade Crossing.</p>",
  "property_virtualtours_blurb": "<p>Can’t make it to Wade Crossing Apartment Homes just yet? No problem!</p><p>Explore our apartments in Frisco, TX from wherever you are with our interactive 360° virtual tours. Get a closer look at apartment layouts, interior finishes, and the spaces that could soon feel like home.</p><p>Take your time exploring, revisit your favorite features, and start narrowing down your options before stepping through the door. When you’re ready, browse available floor plans or schedule an in-person tour with our leasing team.</p>",
  "property_copyright": "2026 All Rights Reserved. Wade Crossing Apartment Homes",
  "property_seo_title_home": "Wade Crossing Apartment Homes | Apartments in Frisco",
  "property_seo_description_home": "Wade Crossing Apartment Homes offers 1, 2 & 3-bedroom apartments in Frisco, TX near Collin College, with two pools, a fitness center, and more.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Frisco | Wade Crossing",
  "property_seo_description_floorplans": "Compare 1, 2 & 3-bedroom floor plans at Wade Crossing in Frisco, TX. Modern, open layouts from 707 to 1,262 sq. ft. View availability and apply online.",
  "property_seo_title_amenities": "Luxury Apartment Amenities in Frisco | Wade Crossing",
  "property_seo_description_amenities": "Enjoy two pools, a 24-hour fitness center, a basketball court, and detached garages at Wade Crossing, offering luxury apartments in Frisco, TX.",
  "property_seo_title_gallery": "Photos of Frisco Apartments for Rent | Wade Crossing",
  "property_seo_description_gallery": "Browse photos of Wade Crossing Apartment Homes in Frisco, TX. See our kitchens, living spaces, two pools, fitness center, and clubhouse. Schedule a tour.",
  "property_seo_title_virtualtours": "Frisco Apartment Virtual Tours | Wade Crossing",
  "property_seo_description_virtualtours": "Tour Wade Crossing Apartment Homes in Frisco, TX from anywhere. Explore our 1, 2 & 3-bedroom apartments and amenities with a 360 virtual tour.",
  "property_seo_title_interactivemap": "Interactive Property Map | Wade Crossing in Frisco, TX",
  "property_seo_description_interactivemap": "Use the Wade Crossing interactive property map to find available apartments in Frisco, TX. Filter by bedrooms, rent, square feet, and move-in date.",
  "property_seo_title_neighborhood": "Frisco Apartments Near Toyota Stadium | Wade Crossing",
  "property_seo_description_neighborhood": "Wade Crossing is on Wade Blvd in Frisco, TX, minutes from Toyota Stadium, The Star, Stonebriar Centre, Collin College, and the Dallas North Tollway.",
  "property_seo_title_contact": "Contact Wade Crossing Apartment Homes | Frisco, TX",
  "property_seo_description_contact": "Contact Wade Crossing Apartment Homes at 9399 Wade Blvd in Frisco, TX. Call (972) 707-2196 or send a message to our leasing team today.",
  "property_seo_title_faqs": "Wade Crossing Apartment Homes FAQ | Frisco, TX",
  "property_seo_description_faqs": "Get answers about applying, leasing, pets, utilities, renters insurance, parking, and amenities at Wade Crossing Apartment Homes in Frisco, TX.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Frisco, TX",
  "property_seo_description_reviews": "Discover vibrant living at Wade Crossing Apartments in Frisco, TX! Hear from our happy residents about spacious homes and great amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Frisco, TX",
  "property_seo_description_applynow": "Find your perfect sanctuary at Wade Crossing in Frisco, TX! Enjoy sleek amenities, spacious floor plans, and vibrant community activities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Wade Crossing Apartment Homes",
  "property_seo_description_residentaccess": "Seamlessly manage your home at Wade Crossing in Frisco, TX. Log into your resident portal for rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Wade Crossing Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Wade Crossing Apartment Homes in Frisco, TX! Great friends make great neighbors—share the love and experience our vibrant community together!",
  "property_seo_title_scheduletour": "Schedule an Apartment Tour in Frisco | Wade Crossing",
  "property_seo_description_scheduletour": "Schedule a guided in-person tour or a 360 virtual tour of Wade Crossing Apartment Homes in Frisco, TX. Pick a date and time that works for you.",
  "property_seo_title_privacy": "Privacy Policy | Wade Crossing Apartment Homes",
  "property_seo_description_privacy": "At Wade Crossing Apartment Homes in Frisco, TX, your peace of mind matters. Read our privacy policy for insights on how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Wade Crossing Apartment Homes",
  "property_seo_description_accessibility": "At Wade Crossing Apartment Homes in Frisco, TX, digital inclusion is our priority. Join a community where everyone can thrive—your comfort matters!",
  "property_seo_title_sitemap": "Sitemap | Wade Crossing Apartment Homes",
  "property_seo_description_sitemap": "Uncover the layout of Wade Crossing Apartment Homes in Frisco, TX. Navigate our sitemap for a seamless journey to your perfect new home.",
  "property_seo_title_thankyou": "Thank You | Wade Crossing Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out! A Wade Crossing team member will connect soon to help you find your new Frisco home. We can’t wait to welcome you!",
  "property_seo_title_pets": "Pet-Friendly Apartments in Frisco, TX | Wade Crossing",
  "property_seo_description_pets": "Wade Crossing offers pet-friendly apartments in Frisco, TX. Review our pet policy, fees, and monthly pet rent, then schedule a tour with your pet in mind.",
  "property_updated_at": "1793628860802",
  "amenities": [
    {
      "id": "ec_d138590e7bda6074381e14b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468402",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-732f-7573-ab29-cf257ce89007.webp",
      "amenity_image_media": {
        "alt_text": "Spacious apartment gym with treadmills, weight machines, and free weights.",
        "public_id": "01a0b673-732f-7573-ab29-cf257ce89007",
        "storage_key": "property/6767906449167621/01a0b673-732f-7573-ab29-cf257ce89007.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Modern Fitness Center at Wade Crossing Apartment Homes, Frisco, TX, 75035",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1037e255e5965125cf4dcf72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87472441",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc991-2969-740b-a123-1c7105be67ed.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor grilling station with lounge chairs and apartment building in the background.",
        "public_id": "019fc991-2969-740b-a123-1c7105be67ed",
        "storage_key": "property/6767906449167621/019fc991-2969-740b-a123-1c7105be67ed.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Outdoor Grill at Wade Crossing Apartment Homes , Texas 75035",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c90170bc286ac68f2ee1c99c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468404",
      "title": "Two Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-7464-709d-8259-2e31b0f33250.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables, surrounded by trees and apartment buildings.",
        "public_id": "01a0b673-7464-709d-8259-2e31b0f33250",
        "storage_key": "property/6767906449167621/01a0b673-7464-709d-8259-2e31b0f33250.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Large Pool at Wade Crossing Apartment Homes, Texas, 75035,Relaxing Pool at Wade Crossing Apartment Homes, Frisco, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ea9fd1e9f405c15cd3e3e9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468403",
      "title": "Detached Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-731e-739d-8f5b-b586aac8c2be.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a multifamily property with attached garages and parking lot.",
        "public_id": "01a0b673-731e-739d-8f5b-b586aac8c2be",
        "storage_key": "property/6767906449167621/01a0b673-731e-739d-8f5b-b586aac8c2be.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Attached Garages at Wade Crossing Apartment Homes, Frisco, TX, 75035",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c072cd5fc9e3c914ea0b18d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87472442",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-7460-70d9-a1c2-9ad9d520dd65.webp",
      "amenity_image_media": {
        "alt_text": "Community room with game table, computers, and seating.",
        "public_id": "01a0b673-7460-70d9-a1c2-9ad9d520dd65",
        "storage_key": "property/6767906449167621/01a0b673-7460-70d9-a1c2-9ad9d520dd65.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "business center at Wade Crossing Apartment Homes , Frisco, Texas, 75035",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6ab9a59e659cdc695369a5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87472440",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc991-b8c7-7728-988d-d52e3a1a79a2.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court and apartment building exterior.",
        "public_id": "019fc991-b8c7-7728-988d-d52e3a1a79a2",
        "storage_key": "property/6767906449167621/019fc991-b8c7-7728-988d-d52e3a1a79a2.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Basketball Court area at Wade Crossing Apartment Homes , Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_abb10155208f64c89ee2c508",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121031647",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ff2f953396095f940eb3d36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468401",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-8202-72ed-b1ca-306bc5afac2c.webp",
      "amenity_image_media": {
        "alt_text": "Living room with leather sofa, patterned chairs, coffee table, and large windows.",
        "public_id": "01a0b673-8202-72ed-b1ca-306bc5afac2c",
        "storage_key": "property/6767906449167621/01a0b673-8202-72ed-b1ca-306bc5afac2c.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "Leasing Office at Wade Crossing Apartment Homes , Texas 75035",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de90a021ca229483b213a88b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87582977",
      "title": "Laundy Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-7fb7-720d-907e-53e5f5e7ff53.webp",
      "amenity_image_media": {
        "alt_text": "Community laundry room with multiple washers and dryers.",
        "public_id": "01a0b673-7fb7-720d-907e-53e5f5e7ff53",
        "storage_key": "property/6767906449167621/01a0b673-7fb7-720d-907e-53e5f5e7ff53.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Laundry Area at Wade Crossing Apartment Homes, Frisco, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21f3776fcf44392ae900247b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87582980",
      "title": "Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-8220-76aa-ab3e-be97942eb681.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with a pool table and fireplace.",
        "public_id": "01a0b673-8220-76aa-ab3e-be97942eb681",
        "storage_key": "property/6767906449167621/01a0b673-8220-76aa-ab3e-be97942eb681.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "billards/pool table located in the resident center at Wade Crossing Apartment Homes , Frisco, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_491b1b374a9c2da0fcad265b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468405",
      "title": "WiFi in the Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_802981913015ba2f7492ed6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "122169241",
      "title": "Flexible Rent Payment Options",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37307ef3dcb4ab0f9688dedc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121031642",
      "title": "Ideal Frisco Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b6b6a86f57a36ef8a07351b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468408",
      "title": "Private Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-82e2-7040-8311-f73d8ced60ff.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and covered patio with seating.",
        "public_id": "01a0b673-82e2-7040-8311-f73d8ced60ff",
        "storage_key": "property/6767906449167621/01a0b673-82e2-7040-8311-f73d8ced60ff.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "View From Balcony at Wade Crossing Apartment Homes, Frisco, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3555ee5932ad62d47423ea21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87472478",
      "title": "Full Kitchen Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-aa87-73f6-82db-12d4c68b0ff1.webp",
      "amenity_image_media": {
        "alt_text": "Modern white kitchen with granite countertops, stainless steel sink, white appliances, and a door.",
        "public_id": "01a0b673-aa87-73f6-82db-12d4c68b0ff1",
        "storage_key": "property/6767906449167621/01a0b673-aa87-73f6-82db-12d4c68b0ff1.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "a kitchen with white cabinets and white appliances at Wade Crossing Apartment Homes, Frisco",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3b9f1386a3b2699697aa3bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121031650",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e1e40b92180a82c1a8b0e1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121031652",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad79aeb005b78d93d54e418b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468406",
      "title": "Cozy Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4b86f01562bbe71e64e4a22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468410",
      "title": "Full Size Washer & Dryer Connections*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92f1eba129bfc3b7d97d4f48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468411",
      "title": "Spacious Closet(s)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57f11203c7f7b052a36f1b37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468412",
      "title": "Spectacular Views Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec4b480874cea90f810f38f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87472472",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f128d7ff52699424c06188ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87472475",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acfd19d332bee354fe89f74c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "87468409",
      "title": "Den/Study*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_723b87328cf3278b4d2e9abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121428821",
      "title": "Vinyl Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_532f54bf11891bc136b8609f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121428836",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea33e201242751792ec935c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "external_id": "121428883",
      "title": "ADA Accessible",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_0fb1caeb87f564b310840c4e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-4c05-75ed-bcea-4d93bf95a955.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, appliances, and granite countertops.",
        "public_id": "01a0b673-4c05-75ed-bcea-4d93bf95a955",
        "storage_key": "property/6767906449167621/01a0b673-4c05-75ed-bcea-4d93bf95a955.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A modern and functional kitchen space featuring sleek white cabinetry, essential appliances, and elegant granite countertops for a comfortable living experience.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/52-9399 Wade Blvd VS-7(3).jpg"
    },
    {
      "id": "ec_5277c8e0dfcc2baf5f3d23cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-d12e-71db-928e-edb9f5a7b61a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel sink.",
        "public_id": "01a0b673-d12e-71db-928e-edb9f5a7b61a",
        "storage_key": "property/6767906449167621/01a0b673-d12e-71db-928e-edb9f5a7b61a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious and well-equipped kitchen featuring ample cabinet space, granite countertops, and a double sink, perfect for home chefs.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/51-9399 Wade Blvd VS-6(1).jpg"
    },
    {
      "id": "ec_a8543984027b8dc3c6f16daf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-d12d-778b-b783-c6ff8eb54abd.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, dining area, and kitchen view.",
        "public_id": "01a0b673-d12d-778b-b783-c6ff8eb54abd",
        "storage_key": "property/6767906449167621/01a0b673-d12d-778b-b783-c6ff8eb54abd.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a mounted TV, comfortable seating, and a connected dining space with a view into the kitchen.",
      "link": "false",
      "alt_text": "Living room with a TV, coffee table, dining area, and kitchen view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-9399 WADE BLVD-13(3).jpg"
    },
    {
      "id": "ec_be06a5b987eaf010d69ca587",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-d1c0-7724-962a-932de36dbaae.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, coffee table, dining set, and a television.",
        "public_id": "01a0b673-d1c0-7724-962a-932de36dbaae",
        "storage_key": "property/6767906449167621/01a0b673-d1c0-7724-962a-932de36dbaae.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, a stylish coffee table, and a dedicated dining space. Enjoy entertainment on the wall-mounted TV.",
      "link": "false",
      "alt_text": "Living room and dining area with a sofa, coffee table, dining set, and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/47-9399 Wade Blvd VS-2(2).jpg"
    },
    {
      "id": "ec_31509d4552cfa40d195f7a61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-baee-7153-ac4e-d0634a2b46ba.webp",
      "image_media": {
        "alt_text": "Bar area with stools and kitchen appliances in the community center.",
        "public_id": "01a0b673-baee-7153-ac4e-d0634a2b46ba",
        "storage_key": "property/6767906449167621/01a0b673-baee-7153-ac4e-d0634a2b46ba.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy community gatherings and events in our stylish lounge area, featuring a full kitchen and ample seating.",
      "link": "false",
      "alt_text": "Bar area with stools and kitchen appliances in the community center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/40-9399 WADE BLVD-40.jpg"
    },
    {
      "id": "ec_2dc26dea152aaf20d59ac481",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-d131-717b-b5ce-982add0c5705.webp",
      "image_media": {
        "alt_text": "Community room with a pool table, bar area, and seating.",
        "public_id": "01a0b673-d131-717b-b5ce-982add0c5705",
        "storage_key": "property/6767906449167621/01a0b673-d131-717b-b5ce-982add0c5705.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy resident gatherings and events in our spacious community room, featuring a pool table, full-service bar, and comfortable seating areas.",
      "link": "false",
      "alt_text": "Community room with a pool table, bar area, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/39-9399 WADE BLVD-39(1).jpg"
    },
    {
      "id": "ec_0cc0b202ba29de5f25b60c95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-c61b-7428-90ba-3cfa4d50beee.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio area with seating and bar.",
        "public_id": "01a0b673-c61b-7428-90ba-3cfa4d50beee",
        "storage_key": "property/6767906449167621/01a0b673-c61b-7428-90ba-3cfa4d50beee.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy relaxing outdoors in this covered patio area, complete with comfortable seating and a bar, perfect for gatherings.",
      "link": "false",
      "alt_text": "Outdoor covered patio area with seating and bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-9399 WADE BLVD-22(1).jpg"
    },
    {
      "id": "ec_59164f359f92ae0cde3f9014",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-d410-772f-a5b9-9eb1386ef162.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
        "public_id": "01a0b673-d410-772f-a5b9-9eb1386ef162",
        "storage_key": "property/6767906449167621/01a0b673-d410-772f-a5b9-9eb1386ef162.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring a variety of cardio machines and weight training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/44-9399 WADE BLVD-44.jpg"
    },
    {
      "id": "ec_8df22fa65ad1b395c0419e09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-f89e-7618-b770-66d1673b9b7e.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "01a0b673-f89e-7618-b770-66d1673b9b7e",
        "storage_key": "property/6767906449167621/01a0b673-f89e-7618-b770-66d1673b9b7e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with treadmills, ellipticals, weight machines, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/43-9399 WADE BLVD-43(1).jpg"
    },
    {
      "id": "ec_b3cd732ab10d16b595c75b35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-e39b-72d7-b9af-4c0f938df6f2.webp",
      "image_media": {
        "alt_text": "Wade Crossing Apartment Homes monument sign with landscaping and modern building in background.",
        "public_id": "01a0b673-e39b-72d7-b9af-4c0f938df6f2",
        "storage_key": "property/6767906449167621/01a0b673-e39b-72d7-b9af-4c0f938df6f2.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Welcome to Wade Crossing Apartment Homes, featuring a beautifully landscaped entrance and modern architecture.",
      "link": "false",
      "alt_text": "Wade Crossing Apartment Homes monument sign with landscaping and modern building in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-9399 WADE BLVD-11 v2(2).jpg"
    },
    {
      "id": "ec_7821cf203df754a78a3550ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-03ee-7368-812c-3ceddf78566b.webp",
      "image_media": {
        "alt_text": "Apartment building with attached garages.",
        "public_id": "01a0b674-03ee-7368-812c-3ceddf78566b",
        "storage_key": "property/6767906449167621/01a0b674-03ee-7368-812c-3ceddf78566b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing its attached garage facilities and a parking lot.",
      "link": "false",
      "alt_text": "Apartment building with attached garages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-9399 WADE BLVD-18_edit.jpg"
    },
    {
      "id": "ec_32052cc6d98e256397ebefab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-f85b-707b-81a2-294717aee3f7.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with multiple buildings, a pool, and surrounding landscape.",
        "public_id": "01a0b673-f85b-707b-81a2-294717aee3f7",
        "storage_key": "property/6767906449167621/01a0b673-f85b-707b-81a2-294717aee3f7.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Spacious apartment community featuring multiple buildings, a sparkling outdoor pool, and well-maintained grounds. Enjoy the convenience of ample parking and beautiful green spaces.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with multiple buildings, a pool, and surrounding landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-9399 WADE BLVD-8.jpg"
    },
    {
      "id": "ec_57bbe6e7374688add00ca7f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-f935-743f-b357-dcb3099b60a9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a pool and clubhouse.",
        "public_id": "01a0b673-f935-743f-b357-dcb3099b60a9",
        "storage_key": "property/6767906449167621/01a0b673-f935-743f-b357-dcb3099b60a9.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience resort-style living with our expansive pool and clubhouse at the heart of our vibrant community.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings surrounding a pool and clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-9399 WADE BLVD-1 v2(2).jpg"
    },
    {
      "id": "ec_951178bb86be1fb65da39b2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-edb1-72bf-8a5e-0e9bd0a98da2.webp",
      "image_media": {
        "alt_text": "Aerial view of a luxury apartment complex with a swimming pool and surrounding buildings.",
        "public_id": "01a0b673-edb1-72bf-8a5e-0e9bd0a98da2",
        "storage_key": "property/6767906449167621/01a0b673-edb1-72bf-8a5e-0e9bd0a98da2.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience resort-style living at our beautiful apartment community, featuring a sparkling swimming pool and lush green spaces.",
      "link": "false",
      "alt_text": "Aerial view of a luxury apartment complex with a swimming pool and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-9399 WADE BLVD-2 v2(2).jpg"
    },
    {
      "id": "ec_8ba423601e8d38def57d7801",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b673-fabf-71dc-acc9-4a0fa78f9c55.webp",
      "image_media": {
        "alt_text": "Chaise lounges and chairs around a swimming pool with a waterfall feature and a building in the background.",
        "public_id": "01a0b673-fabf-71dc-acc9-4a0fa78f9c55",
        "storage_key": "property/6767906449167621/01a0b673-fabf-71dc-acc9-4a0fa78f9c55.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with a serene waterfall and comfortable chaise lounges. Perfect for soaking up the sun.",
      "link": "false",
      "alt_text": "Chaise lounges and chairs around a swimming pool with a waterfall feature and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/42-9399 WADE BLVD-42.jpg"
    },
    {
      "id": "ec_8dbfd8e1fbfb12fbaa709b80",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-07a4-76ce-8ffb-d34aa08ec482.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex pool and surrounding buildings.",
        "public_id": "01a0b674-07a4-76ce-8ffb-d34aa08ec482",
        "storage_key": "property/6767906449167621/01a0b674-07a4-76ce-8ffb-d34aa08ec482.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, perfect for relaxation and fun. Surrounded by lush greenery and comfortable lounge areas, it's the ideal spot to unwind.",
      "link": "false",
      "alt_text": "Aerial view of an apartment complex pool and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/37-9399 WADE BLVD-37(1).jpg"
    },
    {
      "id": "ec_3e5b9d8eebbf2e853d5e756e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-08cd-7124-b6fe-dc4b50244742.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0b674-08cd-7124-b6fe-dc4b50244742",
        "storage_key": "property/6767906449167621/01a0b674-08cd-7124-b6fe-dc4b50244742.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by lush landscaping and the beautiful apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-9399 WADE BLVD-19(2).jpg"
    },
    {
      "id": "ec_0cfb6de26400774dc8b4b655",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-1f5f-7216-b682-c42cfca93501.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
        "public_id": "01a0b674-1f5f-7216-b682-c42cfca93501",
        "storage_key": "property/6767906449167621/01a0b674-1f5f-7216-b682-c42cfca93501.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and a shaded cabana area for your enjoyment.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-9399 WADE BLVD-20(1).jpg"
    },
    {
      "id": "ec_3d61a2caa959b37ba8edb096",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-2075-747e-a257-19375ccb943e.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and lush landscaping.",
        "public_id": "01a0b674-2075-747e-a257-19375ccb943e",
        "storage_key": "property/6767906449167621/01a0b674-2075-747e-a257-19375ccb943e.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoor swimming pool, perfect for relaxing and soaking up the sun. Surrounded by green trees and comfortable lounge chairs, it's an oasis of tranquility.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-9399 WADE BLVD-6(1).jpg"
    },
    {
      "id": "ec_0192d91209eb59efca0ddaf0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-2820-7140-8a91-f9b5a28830bd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a0b674-2820-7140-8a91-f9b5a28830bd",
        "storage_key": "property/6767906449167621/01a0b674-2820-7140-8a91-f9b5a28830bd.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a beautiful water feature. Perfect for a refreshing dip on a sunny day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-9399 WADE BLVD-5(1).jpg"
    },
    {
      "id": "ec_100e3df181196f73d960c4c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-1604-737e-9f1e-5ed569c52a08.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a multi-tiered fountain in front of an apartment building.",
        "public_id": "01a0b674-1604-737e-9f1e-5ed569c52a08",
        "storage_key": "property/6767906449167621/01a0b674-1604-737e-9f1e-5ed569c52a08.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, complete with comfortable lounge chairs and a beautiful multi-tiered fountain. Enjoy the resort-style amenities at our community.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and a multi-tiered fountain in front of an apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-9399 WADE BLVD-3(1).jpg"
    },
    {
      "id": "ec_2b9958718a6abd029af44453",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-2f2c-7611-8b4b-406f19986ee5.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with lush green lawns and mature trees under a blue sky with scattered clouds.",
        "public_id": "01a0b674-2f2c-7611-8b4b-406f19986ee5",
        "storage_key": "property/6767906449167621/01a0b674-2f2c-7611-8b4b-406f19986ee5.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Discover comfortable living in our beautifully maintained apartment community, featuring spacious grounds and attractive exteriors.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with lush green lawns and mature trees under a blue sky with scattered clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-9399 WADE BLVD-9 v2(1).jpg"
    },
    {
      "id": "ec_e1d38112561c699db30a5160",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-36bc-769b-a52a-863d8a27256a.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, and two doors.",
        "public_id": "01a0b674-36bc-769b-a52a-863d8a27256a",
        "storage_key": "property/6767906449167621/01a0b674-36bc-769b-a52a-863d8a27256a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Create a welcoming atmosphere in your dining space with this elegant setup, featuring a round table and comfortable seating. Perfect for intimate meals or entertaining guests.",
      "link": "false",
      "alt_text": "Dining area with a table and chairs, and two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/48-9399 Wade Blvd VS-3(2).jpg"
    },
    {
      "id": "ec_f99e23d3982b865d884f6801",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-299e-700c-803a-d7a74887a347.webp",
      "image_media": {
        "alt_text": "Living room with a ceiling fan, a couch, a coffee table, and a TV.",
        "public_id": "01a0b674-299e-700c-803a-d7a74887a347",
        "storage_key": "property/6767906449167621/01a0b674-299e-700c-803a-d7a74887a347.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a ceiling fan, comfortable seating, a coffee table, and a large TV for entertainment.",
      "link": "false",
      "alt_text": "Living room with a ceiling fan, a couch, a coffee table, and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-9399 WADE BLVD-12(1).jpg"
    },
    {
      "id": "ec_80b94beb201946577bba6eda",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-57cd-74f5-9b3f-e80d9588e7fa.webp",
      "image_media": {
        "alt_text": "Balcony with seating area and view of apartment entrance.",
        "public_id": "01a0b674-57cd-74f5-9b3f-e80d9588e7fa",
        "storage_key": "property/6767906449167621/01a0b674-57cd-74f5-9b3f-e80d9588e7fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, featuring comfortable seating and a direct view of your apartment's entrance.",
      "link": "false",
      "alt_text": "Balcony with seating area and view of apartment entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-9399 WADE BLVD-17_edit.jpg"
    },
    {
      "id": "ec_e7657cdf8a24fdcede8c43bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-4e7d-7535-bfc8-b0b5f3da58fb.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, sink, toilet, and bathtub with a navy shower curtain.",
        "public_id": "01a0b674-4e7d-7535-bfc8-b0b5f3da58fb",
        "storage_key": "property/6767906449167621/01a0b674-4e7d-7535-bfc8-b0b5f3da58fb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a sleek white vanity with a granite countertop, a pristine sink, a clean toilet, and a bathtub complemented by a stylish navy shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with white vanity, sink, toilet, and bathtub with a navy shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-9399 WADE BLVD-16(1).jpg"
    },
    {
      "id": "ec_48688057babff17e2f462c4b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-356d-70cf-a0f9-3db12dac270e.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, nightstand, and closet.",
        "public_id": "01a0b674-356d-70cf-a0f9-3db12dac270e",
        "storage_key": "property/6767906449167621/01a0b674-356d-70cf-a0f9-3db12dac270e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a comfortable queen-size bed, elegant nightstand, and ample closet space. Perfect for relaxation.",
      "link": "false",
      "alt_text": "A bedroom with a queen-size bed, nightstand, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-9399 WADE BLVD-15(1).jpg"
    },
    {
      "id": "ec_0361297c154cf021e2aacc2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-4e3e-7674-8c79-7a4990def5c0.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and window with curtains.",
        "public_id": "01a0b674-4e3e-7674-8c79-7a4990def5c0",
        "storage_key": "property/6767906449167621/01a0b674-4e3e-7674-8c79-7a4990def5c0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant ceiling fan, and large window with decorative curtains for ample natural light.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and window with curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-9399 WADE BLVD-14.jpg"
    },
    {
      "id": "ec_66df640b05c2e976b84906a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-56f0-75be-8fc5-fbdbeba96ba8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and windows overlooking the exterior.",
        "public_id": "01a0b674-56f0-75be-8fc5-fbdbeba96ba8",
        "storage_key": "property/6767906449167621/01a0b674-56f0-75be-8fc5-fbdbeba96ba8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this inviting bedroom, featuring a plush queen-size bed, elegant nightstands, and large windows that bathe the room in natural light.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and windows overlooking the exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/57-9399 Wade Blvd VS-12(1).jpg"
    },
    {
      "id": "ec_c8fded144d41bc3ef4e6aeac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-56f3-767c-9aa1-d3afdf80502e.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, adjacent to a kitchen pass-through.",
        "public_id": "01a0b674-56f3-767c-9aa1-d3afdf80502e",
        "storage_key": "property/6767906449167621/01a0b674-56f3-767c-9aa1-d3afdf80502e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining area perfect for entertaining, with a modern table and chairs, open to the kitchen.",
      "link": "false",
      "alt_text": "Dining area with a round table and four chairs, adjacent to a kitchen pass-through.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/50-9399 Wade Blvd VS-5(2).jpg"
    },
    {
      "id": "ec_bef0c5b5bc9290dc8106fe50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-5981-779e-9642-d8ad7e026ba0.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and walk-in closet with shelves.",
        "public_id": "01a0b674-5981-779e-9642-d8ad7e026ba0",
        "storage_key": "property/6767906449167621/01a0b674-5981-779e-9642-d8ad7e026ba0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity with a sink, ample counter space, and a large mirror. A walk-in closet with built-in shelving offers convenient storage solutions.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and walk-in closet with shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/56-9399 Wade Blvd VS-11.jpg"
    },
    {
      "id": "ec_2d6170b48063daf7bf62ca04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-5bfe-7214-b631-09276f3cf19e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and closet.",
        "public_id": "01a0b674-5bfe-7214-b631-09276f3cf19e",
        "storage_key": "property/6767906449167621/01a0b674-5bfe-7214-b631-09276f3cf19e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern ceiling fan, and a walk-in closet for ample storage.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/55-9399 Wade Blvd VS-10(2).jpg"
    },
    {
      "id": "ec_888afbb736d9414512bc1400",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-7d38-7422-904e-fee4420b1d63.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a king-sized bed, nightstands, and a ceiling fan.",
        "public_id": "01a0b674-7d38-7422-904e-fee4420b1d63",
        "storage_key": "property/6767906449167621/01a0b674-7d38-7422-904e-fee4420b1d63.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, modern nightstands, and an overhead ceiling fan. An en-suite bathroom and closet are accessible through adjacent doors.",
      "link": "false",
      "alt_text": "A staged bedroom with a king-sized bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/54-9399 Wade Blvd VS-9(3).jpg"
    },
    {
      "id": "ec_0b1d073e96415d3d2726df9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-7e08-752c-8f9d-0661577c1a9f.webp",
      "image_media": {
        "alt_text": "A bed with gray and tan bedding, decorative pillows, and a ceiling fan overhead.",
        "public_id": "01a0b674-7e08-752c-8f9d-0661577c1a9f",
        "storage_key": "property/6767906449167621/01a0b674-7e08-752c-8f9d-0661577c1a9f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed with plush bedding and a stylish ceiling fan.",
      "link": "false",
      "alt_text": "A bed with gray and tan bedding, decorative pillows, and a ceiling fan overhead.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/53-9399 Wade Blvd VS-8.jpg"
    },
    {
      "id": "ec_518ad2cb671fb64b4f0db93d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-7f8d-750d-af52-2a21a6b60c53.webp",
      "image_media": {
        "alt_text": "Dining area and living room with balcony access.",
        "public_id": "01a0b674-7f8d-750d-af52-2a21a6b60c53",
        "storage_key": "property/6767906449167621/01a0b674-7f8d-750d-af52-2a21a6b60c53.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Open-concept living and dining area featuring a round dining table and a spacious living room with balcony access, perfect for comfortable modern living.",
      "link": "false",
      "alt_text": "Dining area and living room with balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/49-9399 Wade Blvd VS-4(2).jpg"
    },
    {
      "id": "ec_deea5f69bccabd19cabb6640",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-7d3e-74ba-bce7-e685a0032d8e.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and mounted TV.",
        "public_id": "01a0b674-7d3e-74ba-bce7-e685a0032d8e",
        "storage_key": "property/6767906449167621/01a0b674-7d3e-74ba-bce7-e685a0032d8e.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable gray sofa, stylish coffee table, and entertainment center with a mounted television.",
      "link": "false",
      "alt_text": "Living room with gray sofa, coffee table, and mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/46-9399 Wade Blvd VS-1(1).jpg"
    },
    {
      "id": "ec_e6ac0c985d63ebc021d09735",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-7404-7486-a1aa-c9062ff5fe0c.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "01a0b674-7404-7486-a1aa-c9062ff5fe0c",
        "storage_key": "property/6767906449167621/01a0b674-7404-7486-a1aa-c9062ff5fe0c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with washers and dryers available for resident use.",
      "link": "false",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/38-9399 WADE BLVD-38(2).jpg"
    },
    {
      "id": "ec_b9294600b38dc7c62dcbbe1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-7da9-76c7-a458-10c4d5634e6f.webp",
      "image_media": {
        "alt_text": "Balcony view overlooking the pool and surrounding apartment buildings.",
        "public_id": "01a0b674-7da9-76c7-a458-10c4d5634e6f",
        "storage_key": "property/6767906449167621/01a0b674-7da9-76c7-a458-10c4d5634e6f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening wine on this private balcony, with a view of the sparkling pool and lush landscaping.",
      "link": "false",
      "alt_text": "Balcony view overlooking the pool and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/35-9399 Wade Blvd VS-13(1).jpg"
    },
    {
      "id": "ec_52bdbd46c8e8ce211c91a056",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-901a-7338-90e9-61584ebdcc50.webp",
      "image_media": {
        "alt_text": "Outdoor barbecue grill in a grassy common area with houses and trees in the background.",
        "public_id": "01a0b674-901a-7338-90e9-61584ebdcc50",
        "storage_key": "property/6767906449167621/01a0b674-901a-7338-90e9-61584ebdcc50.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and gathering with friends and family at the community barbecue grill, located in a scenic grassy area.",
      "link": "false",
      "alt_text": "Outdoor barbecue grill in a grassy common area with houses and trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6894.jpg"
    },
    {
      "id": "ec_093a842fcb08a639aa0b548f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-8f13-70c8-9963-23a4d9c740e6.webp",
      "image_media": {
        "alt_text": "Conference room with a large oval table and executive chairs.",
        "public_id": "01a0b674-8f13-70c8-9963-23a4d9c740e6",
        "storage_key": "property/6767906449167621/01a0b674-8f13-70c8-9963-23a4d9c740e6.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Conduct your next meeting in our fully equipped conference room, perfect for business needs.",
      "link": "false",
      "alt_text": "Conference room with a large oval table and executive chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6954.jpg"
    },
    {
      "id": "ec_ebb4a35382daa63431457953",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-92c3-7130-8012-156832d80627.webp",
      "image_media": {
        "alt_text": "Interior lounge area with comfortable seating and large windows overlooking the exterior.",
        "public_id": "01a0b674-92c3-7130-8012-156832d80627",
        "storage_key": "property/6767906449167621/01a0b674-92c3-7130-8012-156832d80627.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious and inviting lounge area. Enjoy the natural light from the large windows and comfortable seating options.",
      "link": "false",
      "alt_text": "Interior lounge area with comfortable seating and large windows overlooking the exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6993.jpg"
    },
    {
      "id": "ec_4110f488d2ce5c42f6e5cd21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-a7e0-751c-acbc-7849ef8a8d4d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0b674-a7e0-751c-acbc-7849ef8a8d4d",
        "storage_key": "property/6767906449167621/01a0b674-a7e0-751c-acbc-7849ef8a8d4d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for a sunny day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6978.jpg"
    },
    {
      "id": "ec_b0c437bfaabccc84f08a4a42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-a88c-77c9-a2bd-c6c899a2741d.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather sofa, patterned armchairs, and coffee table.",
        "public_id": "01a0b674-a88c-77c9-a2bd-c6c899a2741d",
        "storage_key": "property/6767906449167621/01a0b674-a88c-77c9-a2bd-c6c899a2741d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lobby, featuring comfortable seating and large windows with picturesque views.",
      "link": "false",
      "alt_text": "Lobby seating area with leather sofa, patterned armchairs, and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6990.jpg"
    },
    {
      "id": "ec_3a44800700ec13a0661bbaf0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-bbce-74ef-a0f9-0747189702ff.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather sofas and patterned accent chairs.",
        "public_id": "01a0b674-bbce-74ef-a0f9-0747189702ff",
        "storage_key": "property/6767906449167621/01a0b674-bbce-74ef-a0f9-0747189702ff.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Relax in our beautifully appointed lobby, featuring comfortable seating and ample natural light. A perfect space to unwind or greet guests.",
      "link": "false",
      "alt_text": "Lobby seating area with leather sofas and patterned accent chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6981.jpg"
    },
    {
      "id": "ec_6d1acfe7789a78631d3daf5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-a52b-75cb-a93d-89456b577d2a.webp",
      "image_media": {
        "alt_text": "Spacious lobby with a rustic coffee table, leather sofa, and patterned accent chair.",
        "public_id": "01a0b674-a52b-75cb-a93d-89456b577d2a",
        "storage_key": "property/6767906449167621/01a0b674-a52b-75cb-a93d-89456b577d2a.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lobby, featuring comfortable seating and a welcoming ambiance.",
      "link": "false",
      "alt_text": "Spacious lobby with a rustic coffee table, leather sofa, and patterned accent chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6999.jpg"
    },
    {
      "id": "ec_e3888f29bd324017318c83cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-a398-71c6-8d20-0b915f2e35b9.webp",
      "image_media": {
        "alt_text": "Conference room with a large table, chairs, and computers.",
        "public_id": "01a0b674-a398-71c6-8d20-0b915f2e35b9",
        "storage_key": "property/6767906449167621/01a0b674-a398-71c6-8d20-0b915f2e35b9.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Professional conference room available for resident use, complete with computers and Wi-Fi.",
      "link": "false",
      "alt_text": "Conference room with a large table, chairs, and computers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6948.jpg"
    },
    {
      "id": "ec_bc3d29b109f63ae26cbdd74a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-ce9b-763b-bd1d-901e26e29074.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, fireplace, and seating area.",
        "public_id": "01a0b674-ce9b-763b-bd1d-901e26e29074",
        "storage_key": "property/6767906449167621/01a0b674-ce9b-763b-bd1d-901e26e29074.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a billiards table, cozy fireplace, and comfortable seating. Perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "Community lounge with a pool table, fireplace, and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6936.jpg"
    },
    {
      "id": "ec_c47a122d097b6eb3d9eaa8af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-cddd-77ec-928c-51744148cc6d.webp",
      "image_media": {
        "alt_text": "Community lounge area with a fireplace and a billiards table.",
        "public_id": "01a0b674-cddd-77ec-928c-51744148cc6d",
        "storage_key": "property/6767906449167621/01a0b674-cddd-77ec-928c-51744148cc6d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a cozy fireplace and a billiards table for entertainment.",
      "link": "false",
      "alt_text": "Community lounge area with a fireplace and a billiards table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6942.jpg"
    },
    {
      "id": "ec_fbb6db43cf42c71d597e54f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-be14-705f-a4b5-c1989d44f470.webp",
      "image_media": {
        "alt_text": "Community room with a pool table, fireplace, and bar area.",
        "public_id": "01a0b674-be14-705f-a4b5-c1989d44f470",
        "storage_key": "property/6767906449167621/01a0b674-be14-705f-a4b5-c1989d44f470.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation in our community's well-appointed club room, featuring a pool table, fireplace, and bar.",
      "link": "false",
      "alt_text": "Community room with a pool table, fireplace, and bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6945.jpg"
    },
    {
      "id": "ec_f75b8beb9b2eda707dfb6ab4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-d7ce-7658-bb51-4e23ac3339b8.webp",
      "image_media": {
        "alt_text": "Living room with a dark wood coffee table, a sectional sofa, and a chair with striped upholstery.",
        "public_id": "01a0b674-d7ce-7658-bb51-4e23ac3339b8",
        "storage_key": "property/6767906449167621/01a0b674-d7ce-7658-bb51-4e23ac3339b8.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "This stylish living room features a comfortable sectional sofa, a dark wood coffee table, and a decorative armchair, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with a dark wood coffee table, a sectional sofa, and a chair with striped upholstery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6897.jpg"
    },
    {
      "id": "ec_0b81bf6bc08cff7cd58e0842",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-e8dd-75cd-8a6d-829d514ac97d.webp",
      "image_media": {
        "alt_text": "Community center kitchen area with a counter and bar stools.",
        "public_id": "01a0b674-e8dd-75cd-8a6d-829d514ac97d",
        "storage_key": "property/6767906449167621/01a0b674-e8dd-75cd-8a6d-829d514ac97d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in the community center's kitchen area, featuring a full-size refrigerator and microwave, and ample seating at the bar.",
      "link": "false",
      "alt_text": "Community center kitchen area with a counter and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6957.jpg"
    },
    {
      "id": "ec_9676f7f46862baa007a51bdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-d2a3-7709-8cb1-ffd7f155a040.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and decorative items.",
        "public_id": "01a0b674-d2a3-7709-8cb1-ffd7f155a040",
        "storage_key": "property/6767906449167621/01a0b674-d2a3-7709-8cb1-ffd7f155a040.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, stylish coffee table, and tasteful decor, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, and decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6909.jpg"
    },
    {
      "id": "ec_a8ff584ff40fc7e890da7635",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-f3fc-70ae-b517-11ab76a709af.webp",
      "image_media": {
        "alt_text": "Living room with TV, coffee table, couch, and dining area in background",
        "public_id": "01a0b674-f3fc-70ae-b517-11ab76a709af",
        "storage_key": "property/6767906449167621/01a0b674-f3fc-70ae-b517-11ab76a709af.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furnishings, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room with TV, coffee table, couch, and dining area in background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6903.jpg"
    },
    {
      "id": "ec_1d925391da4d3b786697245b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-e09c-7688-8893-b6aaf2551fb3.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs next to kitchen counter and apartment entrance doors.",
        "public_id": "01a0b674-e09c-7688-8893-b6aaf2551fb3",
        "storage_key": "property/6767906449167621/01a0b674-e09c-7688-8893-b6aaf2551fb3.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, adjacent to a modern kitchen counter and conveniently located near your apartment entrance.",
      "link": "false",
      "alt_text": "Dining area with table and chairs next to kitchen counter and apartment entrance doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6900.jpg"
    },
    {
      "id": "ec_e486131a410d94db43b9b0da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-e40d-7687-a651-0a23ee7c2a4d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "01a0b674-e40d-7687-a651-0a23ee7c2a4d",
        "storage_key": "property/6767906449167621/01a0b674-e40d-7687-a651-0a23ee7c2a4d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, granite countertops, and a separate dining area, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6921.jpg"
    },
    {
      "id": "ec_936b853273f1d5cbcb2d44f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-fef6-744c-aac9-b469a92f167f.webp",
      "image_media": {
        "alt_text": "Outdoor grill in a grassy courtyard with apartment buildings in the background.",
        "public_id": "01a0b674-fef6-744c-aac9-b469a92f167f",
        "storage_key": "property/6767906449167621/01a0b674-fef6-744c-aac9-b469a92f167f.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with the community grill located in the spacious courtyard, surrounded by beautiful apartment homes.",
      "link": "false",
      "alt_text": "Outdoor grill in a grassy courtyard with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6891.jpg"
    },
    {
      "id": "ec_1780f96f6717ac51a16dd9d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-f3ba-712d-bafb-b02824657b3a.webp",
      "image_media": {
        "alt_text": "Lobby area with leather sofas, accent chairs, coffee table, and large windows.",
        "public_id": "01a0b674-f3ba-712d-bafb-b02824657b3a",
        "storage_key": "property/6767906449167621/01a0b674-f3ba-712d-bafb-b02824657b3a.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Welcome to our spacious and comfortable lobby, perfect for relaxing or meeting guests. Enjoy the natural light streaming through the large windows.",
      "link": "false",
      "alt_text": "Lobby area with leather sofas, accent chairs, coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6987.jpg"
    },
    {
      "id": "ec_9e04b72bedbda34e94b474cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-0d85-7716-89c6-3b9001a67581.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sectional sofa, coffee table, dining table, and bar seating.",
        "public_id": "01a0b675-0d85-7716-89c6-3b9001a67581",
        "storage_key": "property/6767906449167621/01a0b675-0d85-7716-89c6-3b9001a67581.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring comfortable seating, a well-appointed dining space, and a breakfast bar, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area with sectional sofa, coffee table, dining table, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6906.jpg"
    },
    {
      "id": "ec_5ec57196f6e410a2a5f8d775",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b674-ff56-708b-bd14-75babfee9ee3.webp",
      "image_media": {
        "alt_text": "Wade Crossing Apartment Homes monument sign with landscaping.",
        "public_id": "01a0b674-ff56-708b-bd14-75babfee9ee3",
        "storage_key": "property/6767906449167621/01a0b674-ff56-708b-bd14-75babfee9ee3.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Welcome to Wade Crossing Apartment Homes, featuring a prominent monument sign with elegant landscaping.",
      "link": "false",
      "alt_text": "Wade Crossing Apartment Homes monument sign with landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6972.jpg"
    },
    {
      "id": "ec_2bf05fa6277c132282ee1147",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-25ab-7506-b1f3-68179a0f4ec7.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather sofa, accent chair, coffee table, and large windows.",
        "public_id": "01a0b675-25ab-7506-b1f3-68179a0f4ec7",
        "storage_key": "property/6767906449167621/01a0b675-25ab-7506-b1f3-68179a0f4ec7.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Welcome guests into a comfortable lobby featuring plush seating, ample natural light, and stylish decor. A perfect space for relaxation or waiting.",
      "link": "false",
      "alt_text": "Lobby seating area with leather sofa, accent chair, coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6984.jpg"
    },
    {
      "id": "ec_bb4191227da2fb4d6f3597b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-0f6c-718b-9a89-7a3a99851c67.webp",
      "image_media": {
        "alt_text": "Lounge chairs and umbrella by a BBQ grill at a multifamily property.",
        "public_id": "01a0b675-0f6c-718b-9a89-7a3a99851c67",
        "storage_key": "property/6767906449167621/01a0b675-0f6c-718b-9a89-7a3a99851c67.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy outdoor living with lounge chairs, an umbrella, and a BBQ grill, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Lounge chairs and umbrella by a BBQ grill at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6975.jpg"
    },
    {
      "id": "ec_e88dc4adb9a0d477c9141a52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-164f-706c-a193-c80b01e39fbd.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather sofa and coffee table, near building entrance.",
        "public_id": "01a0b675-164f-706c-a193-c80b01e39fbd",
        "storage_key": "property/6767906449167621/01a0b675-164f-706c-a193-c80b01e39fbd.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Relax in our inviting lobby, featuring comfortable seating and a welcoming atmosphere for residents and guests.",
      "link": "false",
      "alt_text": "Lobby seating area with leather sofa and coffee table, near building entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6996.jpg"
    },
    {
      "id": "ec_0340aeb1b22e4e8ee5a43ac7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-2c59-70ec-b44f-9d8dec7d73de.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, fireplace, and seating area.",
        "public_id": "01a0b675-2c59-70ec-b44f-9d8dec7d73de",
        "storage_key": "property/6767906449167621/01a0b675-2c59-70ec-b44f-9d8dec7d73de.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, complete with a billiards table, cozy fireplace, and comfortable seating. Perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "Community lounge with a pool table, fireplace, and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/8F4A6939.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ee6c790f-e6d9-4858-8ddd-534fc566a1c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Coffee U",
      "poi_type": "Restaurants",
      "poi_address": "8877 Wade Blvd #300, Frisco, TX 75034, USA",
      "poi_short_description": "Coffee shop featuring specialty lattes (including iced varieties), pastries and sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-3dba-701e-97f2-9f744d92d06c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-3dba-701e-97f2-9f744d92d06c",
        "storage_key": "property/6767906449167621/01a0b66f-3dba-701e-97f2-9f744d92d06c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coffeeufrisco.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4518699335384927324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coffee-u",
      "poi_latitude": "33.1280265",
      "poi_longitude": "-96.8064228",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-618-0495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9635-762d-9795-adeb2dfa8c86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9635-762d-9795-adeb2dfa8c86",
        "storage_key": "property/6767906449167621/019fc995-9635-762d-9795-adeb2dfa8c86.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJzf2P7Dw9TIYRXIxpvBqltT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_3d92ad41-073b-4a84-9545-ef93535df6af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Diner",
      "poi_type": "Restaurants",
      "poi_address": "9250 Dallas Pkwy #160, Frisco, TX 75033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0100a-5235-7502-a355-746ccc5d752f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-5235-7502-a355-746ccc5d752f",
        "storage_key": "property/6767906449167621/01a0100a-5235-7502-a355-746ccc5d752f.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://friscodiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4078204442303102685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-diner",
      "poi_latitude": "33.1544877",
      "poi_longitude": "-96.8393921",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-618-0652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-ZuNFQ5TIYR3X7lQFWxmDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_5809d56b-069e-4992-93bf-ceaa255cd060",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "The Heritage Table",
      "poi_type": "Restaurants",
      "poi_address": "7110 Main St, Frisco, TX 75033, USA",
      "poi_short_description": "Charming neighborhood eatery featuring thoughtfully sourced, refined comfort food & cocktails.",
      "poi_long_description": "Charming neighborhood eatery featuring thoughtfully sourced, refined comfort food & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc993-b4a9-7636-94ef-a84efb34ed54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-b4a9-7636-94ef-a84efb34ed54",
        "storage_key": "property/6767906449167621/019fc993-b4a9-7636-94ef-a84efb34ed54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theheritagetable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9144379154027266819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-heritage-table",
      "poi_latitude": "33.1505987",
      "poi_longitude": "-96.8224939",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-664-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVl0dxA8TIYRA0NIP2Rc534",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_90df31dc-adb4-4250-9800-8c3bc410e617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "La Finca Coffee & Bakery",
      "poi_type": "Restaurants",
      "poi_address": "7511 Main St #150, Frisco, TX 75034, USA",
      "poi_short_description": "Relaxed spot serving Mexican-inspired food, tacos, baked goods and desserts, plus espresso-based coffee drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-58ea-7000-86e5-a7b633d3f389.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-58ea-7000-86e5-a7b633d3f389",
        "storage_key": "property/6767906449167621/01a0b66f-58ea-7000-86e5-a7b633d3f389.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lafincacoffeebakery.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=381331987415738338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-finca-coffee--bakery",
      "poi_latitude": "33.1495718",
      "poi_longitude": "-96.8205924",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-486-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9635-762d-9795-adeb2dfa8c86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9635-762d-9795-adeb2dfa8c86",
        "storage_key": "property/6767906449167621/019fc995-9635-762d-9795-adeb2dfa8c86.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJbylOWF89TIYR4qdoE2zDSgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_cf073389-f6e4-43cf-a737-307ece293324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Eggsquisite Cafe Frisco",
      "poi_type": "Restaurants",
      "poi_address": "6801 Warren Pkwy #101, Frisco, TX 75034, USA",
      "poi_short_description": "Casual dining outlet serving pancakes, eggs Benedict, waffles and skillets, plus coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-43e4-7368-aaae-08e7f86a3fd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-43e4-7368-aaae-08e7f86a3fd5",
        "storage_key": "property/6767906449167621/01a0b66f-43e4-7368-aaae-08e7f86a3fd5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eggsquisitefrisco.wixsite.com/eggsquisite-cafe",
      "poi_directions_map_url": "https://maps.google.com/?cid=115253889192559375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eggsquisite-cafe-frisco",
      "poi_latitude": "33.1062143",
      "poi_longitude": "-96.825799",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-200-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnbl8mi89TIYRDwNONM12mQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c4c4fcae-9ed8-4486-9f9e-f324d423f164",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Hutchins BBQ",
      "poi_type": "Restaurants",
      "poi_address": "9225 Preston Rd, Frisco, TX 75033, USA",
      "poi_short_description": "Local BBQ fixture serving up brisket, ribs & fried catfish in rustic-chic surrounds.",
      "poi_long_description": "Local BBQ fixture serving up brisket, ribs & fried catfish in rustic-chic surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc98e-b5f9-7575-a63e-5a78c0686bd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-b5f9-7575-a63e-5a78c0686bd0",
        "storage_key": "property/6767906449167621/019fc98e-b5f9-7575-a63e-5a78c0686bd0.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://hutchinsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1884774704280475398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hutchins-bbq",
      "poi_latitude": "33.1545813",
      "poi_longitude": "-96.8047681",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-377-2046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZp5CSU8TIYRBpdHipsQKBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b739ad2d-172b-4f07-b27c-443895825efb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Platia Greek Kouzina",
      "poi_type": "Restaurants",
      "poi_address": "2995 Preston Rd #1590, Frisco, TX 75034, USA",
      "poi_short_description": "Casual BYOB eatery for traditional Greek fare in a cozy space with a stone-&-brick-courtyard decor.",
      "poi_long_description": "Casual BYOB eatery for traditional Greek fare in a cozy space with a stone-&-brick-courtyard decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-3c03-7110-a221-bbc15ad98e7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-3c03-7110-a221-bbc15ad98e7a",
        "storage_key": "property/6767906449167621/01a0b66f-3c03-7110-a221-bbc15ad98e7a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.platiagreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9934740184507165725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "platia-greek-kouzina",
      "poi_latitude": "33.1038894",
      "poi_longitude": "-96.8085861",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-334-0031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqTPEyu08TIYRHSxZsY9J34k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_18102156-90f0-4997-b7d6-11c318cc8227",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Tupelo Honey Southern Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "6725 Winning Dr, Frisco, TX 75034, USA",
      "poi_short_description": "National chain for Carolina-inspired takes on made-from-scratch southern dishes & craft cocktails.",
      "poi_long_description": "National chain for Carolina-inspired takes on made-from-scratch southern dishes & craft cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-3c7c-7651-9f86-f3e98af91836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-3c7c-7651-9f86-f3e98af91836",
        "storage_key": "property/6767906449167621/01a0b66f-3c7c-7651-9f86-f3e98af91836.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://tupelohoneycafe.com/restaurant/frisco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16965140246624687071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tupelo-honey-southern-kitchen--bar",
      "poi_latitude": "33.1071829",
      "poi_longitude": "-96.8276887",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-403-2160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbNj3YQ8TIYR31O_TCtJcOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_71eda88f-d42d-423d-aae4-b7bcfccd51d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Umiya Sushi Seafood and Grill",
      "poi_type": "Restaurants",
      "poi_address": "3141 Preston Rd, Frisco, TX 75034, USA",
      "poi_short_description": "Casual locale turning out sushi, hibachi steak, seafood dishes and all-you-can-eat menus.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-43e1-722f-a47e-75c59caad65b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-43e1-722f-a47e-75c59caad65b",
        "storage_key": "property/6767906449167621/01a0b66f-43e1-722f-a47e-75c59caad65b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.umiyafrisco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16742696737940510001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umiya-sushi-seafood-and-grill",
      "poi_latitude": "33.105652",
      "poi_longitude": "-96.8067877",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-407-8066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbLiFQA9TIYRMRUJ__kBWug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3af4ca54-d48b-4f8f-865c-c04b2f34744b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "2601 Preston Rd #2219, Frisco, TX 75034, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-3db4-77b8-99f0-d3f40df49e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-3db4-77b8-99f0-d3f40df49e62",
        "storage_key": "property/6767906449167621/01a0b66f-3db4-77b8-99f0-d3f40df49e62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/tx/frisco-39.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10837866579921715142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "33.0988361",
      "poi_longitude": "-96.8108501",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-731-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3sSB-s8TIYRxr9PozvWZ5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0380dbf2-ab8c-42c2-9b88-1de655dd6b23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Perry’s Steakhouse & Grille",
      "poi_type": "Restaurants",
      "poi_address": "2440 Parkwood Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_long_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-bd05-74f4-93b5-853ceda47fcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-bd05-74f4-93b5-853ceda47fcc",
        "storage_key": "property/6767906449167621/019ff6c2-bd05-74f4-93b5-853ceda47fcc.webp",
        "width": 533,
        "height": 265
      },
      "poi_business_url": "http://www.perryssteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10688708034723240178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perrys-steakhouse--grille",
      "poi_latitude": "33.099256",
      "poi_longitude": "-96.8158828",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-494-4645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8XkOBus8TIYR8tiKjVPrVZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a2dde590-171f-436d-a323-e3ed74982fbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Smokin' Oak Wood-Fired Pizza and Taproom",
      "poi_type": "Restaurants",
      "poi_address": "Road Store, 2601 Preston Rd #2221, Frisco, TX 75034, USA",
      "poi_short_description": "Relaxed restaurant offering wood-fired pizza and cheese bread, plus a self-serve tap wall for beer wine and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-443a-712f-a83c-e95b005122d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-443a-712f-a83c-e95b005122d7",
        "storage_key": "property/6767906449167621/01a0b66f-443a-712f-a83c-e95b005122d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://smokinoakpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9965919913043925072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smokin-oak-wood-fired-pizza-and-taproom",
      "poi_latitude": "33.0984247",
      "poi_longitude": "-96.8112366",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-971-2328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcyuRc-c9TIYRUJj59FsPToo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_06805c3c-20c9-4dbe-9153-27d5e003fbff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Gloria's Latin Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "8601 Preston Rd, Plano, TX 75024, USA",
      "poi_short_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_long_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-449b-703d-8d91-56107a1aa82c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-449b-703d-8d91-56107a1aa82c",
        "storage_key": "property/6767906449167621/01a0b66f-449b-703d-8d91-56107a1aa82c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gloriascuisine.com/locations/frisco.html?utm_source=google&utm_medium=Yext&y_source=1_MjA1ODAzNDctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8758503825914644533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glorias-latin-cuisine",
      "poi_latitude": "33.0943608",
      "poi_longitude": "-96.8064832",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-668-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_w6ye08TIYRNciKO9N0jHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9d8ba9c1-58b4-4a47-964b-2812c1403c24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Pizzeria Testa",
      "poi_type": "Restaurants",
      "poi_address": "8660 Church St, Frisco, TX 75034, USA",
      "poi_short_description": "Neapolitan pies from a prominent wood-burning oven pair with beers in a rustic setting with patio.",
      "poi_long_description": "Neapolitan pies from a prominent wood-burning oven pair with beers in a rustic setting with patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-bf15-752d-9638-5678f82ca083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-bf15-752d-9638-5678f82ca083",
        "storage_key": "property/6767906449167621/019ff6c2-bf15-752d-9638-5678f82ca083.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pizzeriatesta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3734499456229576216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizzeria-testa",
      "poi_latitude": "33.150646",
      "poi_longitude": "-96.835594",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-200-8015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlz6yGvg7TIYRGA50Hnib0zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_1ef21cc9-1d38-48a6-bbcf-2d7c161d541a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Norma's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "8300 Gaylord Pkwy #19, Frisco, TX 75034, USA",
      "poi_short_description": "Long-running restaurant known for homestyle Southern cooking served in diner-style environs.",
      "poi_long_description": "Long-running restaurant known for homestyle Southern cooking served in diner-style environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-4a8e-74f4-b4b9-753d92ab26fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-4a8e-74f4-b4b9-753d92ab26fa",
        "storage_key": "property/6767906449167621/01a0b66f-4a8e-74f4-b4b9-753d92ab26fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://normascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5877541618492541710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "normas-cafe",
      "poi_latitude": "33.1034092",
      "poi_longitude": "-96.8123758",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-712-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzw_4-w8TIYRDovSIvY4kVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7851959e-a0c5-4752-9919-f88310350ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5190 Preston Rd, Frisco, TX 75034, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a2-f4ca-73a1-a02d-ca612077c922.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a2-f4ca-73a1-a02d-ca612077c922",
        "storage_key": "property/6767906449167621/019ff6a2-f4ca-73a1-a02d-ca612077c922.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/tx/frisco/frisco",
      "poi_directions_map_url": "https://maps.google.com/?cid=10989719101740213955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "33.1217596",
      "poi_longitude": "-96.8027283",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-464-5776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9632-767c-ae8e-f7f7ee5e9f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9632-767c-ae8e-f7f7ee5e9f3f",
        "storage_key": "property/6767906449167621/019fc995-9632-767c-ae8e-f7f7ee5e9f3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZpsg1k8TIYRw-aMCExTg5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9428c97c-b63e-400f-812e-d6e105d855d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Southwest Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7070 Preston Rd, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-4e2e-777e-9a80-0b216984c60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-4e2e-777e-9a80-0b216984c60c",
        "storage_key": "property/6767906449167621/01a0b66f-4e2e-777e-9a80-0b216984c60c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16534315227109537016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-farmers-market",
      "poi_latitude": "33.1370877",
      "poi_longitude": "-96.8036173",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-996-6392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9697-712a-83fb-54cd126d925e",
        "storage_key": "property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_fxWHwA9TIYR-DQytBiwdeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_9c1e016b-3b22-47a6-a5ca-ee08ffeab1ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "11401 Coit Rd, Frisco, TX 75035, USA",
      "poi_short_description": "Neighborhood chain grocery with a deli, bakery, florist, butcher, and pharmacy, plus delivery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0100a-3e92-70e6-8c56-7fc62c39479a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-3e92-70e6-8c56-7fc62c39479a",
        "storage_key": "property/6767906449167621/01a0100a-3e92-70e6-8c56-7fc62c39479a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/frisco/11401-coit-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16939215548442176846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "33.1730346",
      "poi_longitude": "-96.7690685",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-237-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9632-767c-ae8e-f7f7ee5e9f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9632-767c-ae8e-f7f7ee5e9f3f",
        "storage_key": "property/6767906449167621/019fc995-9632-767c-ae8e-f7f7ee5e9f3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5GYgpA_TIYRTm2rIssuFOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1420a7dc-f7be-48b7-9ac4-72fbdff08e82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 S Custer Rd, Frisco, TX 75035, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0100a-433b-7264-bc89-4250ce2cb80c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-433b-7264-bc89-4250ce2cb80c",
        "storage_key": "property/6767906449167621/01a0100a-433b-7264-bc89-4250ce2cb80c.webp",
        "width": 1280,
        "height": 846
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/frisco/custer-star/035/00561?cid=loc_03500561_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18160928084500005278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "33.1771942",
      "poi_longitude": "-96.7353854",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 214-491-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9632-767c-ae8e-f7f7ee5e9f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9632-767c-ae8e-f7f7ee5e9f3f",
        "storage_key": "property/6767906449167621/019fc995-9632-767c-ae8e-f7f7ee5e9f3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVWVj-UVTIYRnsEJRN-TCPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c3154fb4-ad4c-4ec0-adf2-f49ac6815d9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Rx Square Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9201 Warren Pkwy #300, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-543e-7539-87a5-b82bed79fbc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-543e-7539-87a5-b82bed79fbc9",
        "storage_key": "property/6767906449167621/01a0b66f-543e-7539-87a5-b82bed79fbc9.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.rxsquarepharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6232636852649192189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rx-square-pharmacy",
      "poi_latitude": "33.1086889",
      "poi_longitude": "-96.803443",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-238-3619",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-962a-7069-9a63-293779ae0bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-962a-7069-9a63-293779ae0bb0",
        "storage_key": "property/6767906449167621/019fc995-962a-7069-9a63-293779ae0bb0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2TJiYLuRToYR_eopEDLGflY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_22466223-4766-4ffc-a5a7-f8f6115e17e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "10820 Eldorado Pkwy, Frisco, TX 75035, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-5515-720b-aa3a-df2fe3a83ebb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-5515-720b-aa3a-df2fe3a83ebb",
        "storage_key": "property/6767906449167621/01a0b66f-5515-720b-aa3a-df2fe3a83ebb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/frisco/10820-eldorado-pkwy.-34085?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884028189177191737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "33.1751805",
      "poi_longitude": "-96.7863563",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-548-0068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-fd25-7757-b1f9-a5ed750f4bb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c2-fd25-7757-b1f9-a5ed750f4bb6",
        "storage_key": "property/6767906449167621/019ff6c2-fd25-7757-b1f9-a5ed750f4bb6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ5QMtEXI-TIYROZ36aOLUMPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_a600e61c-22ba-4757-b7c0-7506e55f74bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4885 Eldorado Pkwy, Frisco, TX 75033, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-1301-7401-b76c-691566f37a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-1301-7401-b76c-691566f37a7a",
        "storage_key": "property/6767906449167621/019fc994-1301-7401-b76c-691566f37a7a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/frisco-north/2338",
      "poi_directions_map_url": "https://maps.google.com/?cid=11174501617294994056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.1731043",
      "poi_longitude": "-96.8446478",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-464-5745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9697-712a-83fb-54cd126d925e",
        "storage_key": "property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF-gps005TIYRiGrlEATOE5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4e6c9f51-b5e7-4aa2-bf42-e4f0e2b0af29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "16066 State Hwy 121, Frisco, TX 75035, USA",
      "poi_short_description": "Chain specializing in groceries as well as electronics, home goods and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc993-fa82-723e-aa2f-550a6e802549.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-fa82-723e-aa2f-550a6e802549",
        "storage_key": "property/6767906449167621/019fc993-fa82-723e-aa2f-550a6e802549.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/202-frisco-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6069100954225149012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.1280134",
      "poi_longitude": "-96.7365627",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-675-1684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9697-712a-83fb-54cd126d925e",
        "storage_key": "property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz-DEVlAWTIYRVASTkinHOVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_42afa25f-88e6-47f8-8518-008c02051b1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Gliv Flowers",
      "poi_type": "Shopping & Retail",
      "poi_address": "9400 Wade Blvd, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-5561-7524-aae1-eb8fb74c3e0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-5561-7524-aae1-eb8fb74c3e0b",
        "storage_key": "property/6767906449167621/01a0b66f-5561-7524-aae1-eb8fb74c3e0b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://glivflowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14519265934071499928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gliv-flowers",
      "poi_latitude": "33.1320691",
      "poi_longitude": "-96.8021145",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-654-3583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9697-712a-83fb-54cd126d925e",
        "storage_key": "property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5TbQMPE9TIYRmAzDz3DLfsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "florist"
    },
    {
      "id": "custom_e471b5cd-4585-4b5f-a4e0-3aec3df572ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Kid to Kid Frisco",
      "poi_type": "Shopping & Retail",
      "poi_address": "5580 Preston Rd Ste 103, Frisco, TX 75034, USA",
      "poi_short_description": "Consignment chain with a range of used apparel, shoes, gear & toys for babies & children.",
      "poi_long_description": "Consignment chain with a range of used apparel, shoes, gear & toys for babies & children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-5951-70bf-83f3-e4d2a0a5d53a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-5951-70bf-83f3-e4d2a0a5d53a",
        "storage_key": "property/6767906449167621/01a0b66f-5951-70bf-83f3-e4d2a0a5d53a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://kidtokid.com/location/frisco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10372906366247850042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kid-to-kid-frisco",
      "poi_latitude": "33.124077",
      "poi_longitude": "-96.8035506",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-362-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9697-712a-83fb-54cd126d925e",
        "storage_key": "property/6767906449167621/019fc995-9697-712a-83fb-54cd126d925e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXR6dA1o8TIYROlCX0GH3848",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_afcb9c5f-9b14-4dfc-8c8b-6e462012af85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Otis Spears Elementary School",
      "poi_type": "Education",
      "poi_address": "8500 Wade Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-16f6-711b-91e7-ebfe4a77821d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-16f6-711b-91e7-ebfe4a77821d",
        "storage_key": "property/6767906449167621/019fc994-16f6-711b-91e7-ebfe4a77821d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/elementary/spears/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=11980273955317204523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "otis-spears-elementary-school",
      "poi_latitude": "33.1304106",
      "poi_longitude": "-96.8101292",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-633-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwakEQWY8TIYRK8aLKrB7QqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6ffce710-3510-4474-94d8-7b4af03f0c95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Shawnee Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "10701 Preston Vineyard Dr, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-058a-70b5-a342-d630b48dac65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-058a-70b5-a342-d630b48dac65",
        "storage_key": "property/6767906449167621/019ff6a3-058a-70b5-a342-d630b48dac65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/elementary/shawnee-trail/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=14624114786679166724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-trail-elementary-school",
      "poi_latitude": "33.1344306",
      "poi_longitude": "-96.7892477",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-633-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb4bN6LM9TIYRBJeMpupK88o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6a0c3f27-5e64-4a25-b3c2-9098b67bd630",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Claude Curtsinger Elementary School",
      "poi_type": "Education",
      "poi_address": "12450 Jereme Trail, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-5b34-727b-80a0-912202a5fad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-5b34-727b-80a0-912202a5fad4",
        "storage_key": "property/6767906449167621/01a0b66f-5b34-727b-80a0-912202a5fad4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/elementary/curtsinger/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=2546545351181543819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "claude-curtsinger-elementary-school",
      "poi_latitude": "33.1241248",
      "poi_longitude": "-96.7702942",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-633-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWdKUGp89TIYRiymZNYElVyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_562e734d-c6a2-41bf-8eac-39cf8766c276",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Kenneth Rex Talley Elementary School",
      "poi_type": "Education",
      "poi_address": "5900 Coit Rd, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://schools.friscoisd.org/campus/elementary/talley/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=3221203034817814072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenneth-rex-talley-elementary-school",
      "poi_latitude": "33.1263786",
      "poi_longitude": "-96.7671975",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-633-2175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF3KAI5k9TIYRON657xcDtCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3f3c79cd-274e-478a-bbec-96ce6cd7291b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Adelle R. Clark Middle School",
      "poi_type": "Education",
      "poi_address": "4600 Colby Dr, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://schools.friscoisd.org/campus/middle-school/clark/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=4457430393351941781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adelle-r-clark-middle-school",
      "poi_latitude": "33.1170879",
      "poi_longitude": "-96.7956067",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-633-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsY6a1v48TIYRla7FhlP52z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_29919550-a14a-4d1d-9b10-dba1731b94b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Lebanon Trail High School",
      "poi_type": "Education",
      "poi_address": "5151 Ohio Dr, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-42ca-7788-9e98-d9edfc93f17e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-42ca-7788-9e98-d9edfc93f17e",
        "storage_key": "property/6767906449167621/019fc994-42ca-7788-9e98-d9edfc93f17e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/high-school/lebanon-trail/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=7787774988995059165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lebanon-trail-high-school",
      "poi_latitude": "33.122114",
      "poi_longitude": "-96.7994581",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-633-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH_94sVc8TIYR3d24URe8E2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9dbc7b80-961b-4f24-ab1c-982b79d23abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Centennial High School",
      "poi_type": "Education",
      "poi_address": "6901 Coit Rd, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-4c81-7405-891c-596fd45e6350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-4c81-7405-891c-596fd45e6350",
        "storage_key": "property/6767906449167621/019fc994-4c81-7405-891c-596fd45e6350.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscoisd.org/o/chs",
      "poi_directions_map_url": "https://maps.google.com/?cid=8413719816357626135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-high-school",
      "poi_latitude": "33.1365728",
      "poi_longitude": "-96.7695583",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-633-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2fuxgJY9TIYRF0GpXZiJw3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_87c8c93e-f4c0-4cc5-9e9e-0673f91d5532",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Collin College Frisco Campus",
      "poi_type": "Education",
      "poi_address": "9700 Wade Blvd, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-20ac-778a-b8ef-65cb16659935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-20ac-778a-b8ef-65cb16659935",
        "storage_key": "property/6767906449167621/019fc994-20ac-778a-b8ef-65cb16659935.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.collin.edu/campuses/frisco/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3026311489019834043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collin-college-frisco-campus",
      "poi_latitude": "33.132282",
      "poi_longitude": "-96.7939958",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-377-1790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJfI-4kw8TIYRu-614kOe_yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9149e931-c604-46ad-b76d-930569ad1e3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco ISD Early Childhood School",
      "poi_type": "Education",
      "poi_address": "10330 Red Cedar Dr, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-2bae-7482-9fad-672d829f011d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-2bae-7482-9fad-672d829f011d",
        "storage_key": "property/6767906449167621/019fc994-2bae-7482-9fad-672d829f011d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/program-centers/ecs/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=13577384477775099847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-isd-early-childhood-school",
      "poi_latitude": "33.1507483",
      "poi_longitude": "-96.7914822",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-633-3825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Rb5KjM8TIYRx_evGD-PbLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_05da7539-6578-421d-ac35-09c01604eac9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Career and Technical Education Center",
      "poi_type": "Education",
      "poi_address": "9889 Wade Blvd, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-ca15-774c-9280-93c0e54075c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-ca15-774c-9280-93c0e54075c9",
        "storage_key": "property/6767906449167621/019ff6c2-ca15-774c-9280-93c0e54075c9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/program-centers/cte/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=6469383876939011336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "career-and-technical-education-center",
      "poi_latitude": "33.1266377",
      "poi_longitude": "-96.796194",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-633-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN1dayFM8TIYRCNWWHFzex1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f370619a-8aca-45db-ba6a-6be3d39f3862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "National Videogame Museum",
      "poi_type": "Entertainment",
      "poi_address": "8004 Dallas Pkwy, Frisco, TX 75034, USA",
      "poi_short_description": "The history of video games as shown through interactive exhibits, classic machines & consoles.",
      "poi_long_description": "The history of video games as shown through interactive exhibits, classic machines & consoles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc98e-2e23-75d9-8f5f-6d29f8de8533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-2e23-75d9-8f5f-6d29f8de8533",
        "storage_key": "property/6767906449167621/019fc98e-2e23-75d9-8f5f-6d29f8de8533.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.nvmusa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18126713850478865989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-videogame-museum",
      "poi_latitude": "33.1435117",
      "poi_longitude": "-96.8352567",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-668-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95df-7640-80fd-b64ba78863d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95df-7640-80fd-b64ba78863d9",
        "storage_key": "property/6767906449167621/019fc995-95df-7640-80fd-b64ba78863d9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJadhe9vU7TIYRRS7yIjUGj_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_137aadad-1f42-4aed-b4ed-9f5899d82b22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "8004 Dallas Pkwy, Frisco, TX 75034, USA",
      "poi_short_description": "A variety of museums and exhibits celebrating space exploration, model trains, arcade games, science and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-5da1-723a-a4ce-489ef494f747.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-5da1-723a-a4ce-489ef494f747",
        "storage_key": "property/6767906449167621/01a0b66f-5da1-723a-a4ce-489ef494f747.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://friscodiscoverycenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13879654655360992465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-discovery-center",
      "poi_latitude": "33.1438889",
      "poi_longitude": "-96.8352778",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-292-6651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95df-7640-80fd-b64ba78863d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95df-7640-80fd-b64ba78863d9",
        "storage_key": "property/6767906449167621/019fc995-95df-7640-80fd-b64ba78863d9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJadhe9vU7TIYR0YTjGV9wnsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_da4ec7bb-b8eb-4255-b48a-4b7508d5fe69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "6455 Page St, Frisco, TX 75034, USA",
      "poi_short_description": "Local history museum consisting of early & mid-20th-century buildings with various period exhibits.",
      "poi_long_description": "Local history museum consisting of early & mid-20th-century buildings with various period exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-067c-7719-a379-a85632cffb28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-067c-7719-a379-a85632cffb28",
        "storage_key": "property/6767906449167621/019ff6a3-067c-7719-a379-a85632cffb28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscotexas.gov/1355/Frisco-Heritage-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042888653917379690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-heritage-museum",
      "poi_latitude": "33.1488923",
      "poi_longitude": "-96.830804",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-292-5665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95df-7640-80fd-b64ba78863d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95df-7640-80fd-b64ba78863d9",
        "storage_key": "property/6767906449167621/019fc995-95df-7640-80fd-b64ba78863d9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVU8Ewg8TIYRatyrqqI3Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c1d1467a-5083-4ed5-b403-756c74a96679",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Cinemark Frisco Square and XD",
      "poi_type": "Entertainment",
      "poi_address": "5655 Frisco Square Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0100a-520d-702f-b823-2a088d05fe86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-520d-702f-b823-2a088d05fe86",
        "storage_key": "property/6767906449167621/01a0100a-520d-702f-b823-2a088d05fe86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-frisco/cinemark-frisco-square-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTMwNTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11087158864441268273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-frisco-square-and-xd",
      "poi_latitude": "33.1499553",
      "poi_longitude": "-96.8372091",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-705-9901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-962a-7069-9a63-257296ecc752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-962a-7069-9a63-257296ecc752",
        "storage_key": "property/6767906449167621/019fc995-962a-7069-9a63-257296ecc752.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaq-Ivg7TIYRMVhYsz6A3Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ded871af-1914-4a4c-85a5-816e8d681438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "AMC Stonebriar 24",
      "poi_type": "Entertainment",
      "poi_address": "2601 Preston Rd #300, Frisco, TX 75034, USA",
      "poi_short_description": "Chic cinema showing first-run features, plus dine-in services including burgers, popcorn and drinks, plus snacks such as nachos and pretzels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-a460-73a0-b703-1a94fe6df1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-a460-73a0-b703-1a94fe6df1ac",
        "storage_key": "property/6767906449167621/019fc994-a460-73a0-b703-1a94fe6df1ac.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/dallas-ft-worth/amc-stonebriar-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9391914349110379827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-stonebriar-24",
      "poi_latitude": "33.0990904",
      "poi_longitude": "-96.8120989",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-377-0144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-962a-7069-9a63-257296ecc752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-962a-7069-9a63-257296ecc752",
        "storage_key": "property/6767906449167621/019fc995-962a-7069-9a63-257296ecc752.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3sSB-s8TIYRM0WeC1fIVoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_349336ab-61d0-4c24-b86a-d6b34785db0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Dave & Buster's Frisco",
      "poi_type": "Restaurants",
      "poi_address": "2601 Preston Rd #1200, Frisco, TX 75034, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a4-3f39-727d-937a-1974c583463d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-3f39-727d-937a-1974c583463d",
        "storage_key": "property/6767906449167621/019ff6a4-3f39-727d-937a-1974c583463d.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/frisco",
      "poi_directions_map_url": "https://maps.google.com/?cid=16526229260329966515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-frisco",
      "poi_latitude": "33.0989608",
      "poi_longitude": "-96.8110794",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-387-0915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95dd-70ff-94d5-7e0ad5a913f1",
        "storage_key": "property/6767906449167621/019fc995-95dd-70ff-94d5-7e0ad5a913f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3sSB-s8TIYRs1ui2vP1WOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_468130c5-a45b-454f-88a0-aadd038710ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Ford Center",
      "poi_type": "Entertainment",
      "poi_address": "9 Cowboys Way, Frisco, TX 75034, USA",
      "poi_short_description": "Stadium and sports venue hosting Dallas Cowboys practices and Frisco-area high-school football games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc98d-e820-734d-80aa-834dae5e4f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-e820-734d-80aa-834dae5e4f3e",
        "storage_key": "property/6767906449167621/019fc98d-e820-734d-80aa-834dae5e4f3e.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://thestarinfrisco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4512728951113659433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ford-center",
      "poi_latitude": "33.1105911",
      "poi_longitude": "-96.8283481",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-497-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9620-744f-8d21-0ea937c2b772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9620-744f-8d21-0ea937c2b772",
        "storage_key": "property/6767906449167621/019fc995-9620-744f-8d21-0ea937c2b772.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB3pWJ4Q8TIYRKTTAUhJvoD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ababbb1b-5f70-40e7-b353-38769c48ea13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Riders Field",
      "poi_type": "Entertainment",
      "poi_address": "7300 Rough Riders Trl, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-6bbe-730a-a8be-0e92e936ec50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6bbe-730a-a8be-0e92e936ec50",
        "storage_key": "property/6767906449167621/019fc994-6bbe-730a-a8be-0e92e936ec50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milb.com/frisco",
      "poi_directions_map_url": "https://maps.google.com/?cid=10443238818600675338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riders-field",
      "poi_latitude": "33.098583",
      "poi_longitude": "-96.8195144",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9620-744f-8d21-0ea937c2b772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9620-744f-8d21-0ea937c2b772",
        "storage_key": "property/6767906449167621/019fc995-9620-744f-8d21-0ea937c2b772.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmVK3Pg89TIYRCmhD91_W7ZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_8b5dc8aa-9e06-41f4-81c6-5b48413bb74c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Comerica Center",
      "poi_type": "Entertainment",
      "poi_address": "2601 Avenue of the Stars, Frisco, TX 75034, USA",
      "poi_short_description": "Home ice of the Texas Legends basketball team, this venue also hosts ice skating, and other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc98d-f38e-7282-a882-9ca56003278a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-f38e-7282-a882-9ca56003278a",
        "storage_key": "property/6767906449167621/019fc98d-f38e-7282-a882-9ca56003278a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.comericacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3439954267266078823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comerica-center",
      "poi_latitude": "33.1005264",
      "poi_longitude": "-96.8191214",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-387-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0bRtJY8TIYRZ9j7Ly4svS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0760aeaf-6b8f-4e3c-80d4-dbbddfe04e57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Square",
      "poi_type": "Entertainment",
      "poi_address": "8843 Coleman Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "Light-filled square featuring snacks, restaurants and shops.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-67ce-737a-b78a-4e4b21a1d60d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-67ce-737a-b78a-4e4b21a1d60d",
        "storage_key": "property/6767906449167621/01a0b66f-67ce-737a-b78a-4e4b21a1d60d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://livefriscosquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16953498325927028820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-square",
      "poi_latitude": "33.15171160000001",
      "poi_longitude": "-96.8350475",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-885-4506",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn78Dfwg8TIYRVGgPaefsRus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_1c427dde-62a9-410c-8a93-b379a56bb863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Texas Health Hospital Frisco",
      "poi_type": "Health and Wellness",
      "poi_address": "12400 Dallas Pkwy, Frisco, TX 75033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-6e06-753f-b15d-fdfdf648e204.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6e06-753f-b15d-fdfdf648e204",
        "storage_key": "property/6767906449167621/019fc994-6e06-753f-b15d-fdfdf648e204.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-frisco",
      "poi_directions_map_url": "https://maps.google.com/?cid=15050624480550683278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-hospital-frisco",
      "poi_latitude": "33.1821898",
      "poi_longitude": "-96.8380121",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-495-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-99b5-700b-ae3d-5c1e8aae003e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-99b5-700b-ae3d-5c1e8aae003e",
        "storage_key": "property/6767906449167621/019fc995-99b5-700b-ae3d-5c1e8aae003e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSYbgAU5TIYRjoIFMzmP3tA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d520500f-4c34-4ae0-a75b-edaf80a52810",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - Frisco",
      "poi_type": "Health and Wellness",
      "poi_address": "5601 Warren Pkwy, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-48e7-77be-805e-43ebf4b40c7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-48e7-77be-805e-43ebf4b40c7a",
        "storage_key": "property/6767906449167621/019fc995-48e7-77be-805e-43ebf4b40c7a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "http://baylorfrisco.com/?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-3359774",
      "poi_directions_map_url": "https://maps.google.com/?cid=2822140024902615889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-medical-center---frisco",
      "poi_latitude": "33.1046353",
      "poi_longitude": "-96.8379875",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-407-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-99b5-700b-ae3d-5c1e8aae003e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-99b5-700b-ae3d-5c1e8aae003e",
        "storage_key": "property/6767906449167621/019fc995-99b5-700b-ae3d-5c1e8aae003e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVFfLH07TIYRUYO7emZBKic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c2d8946f-3451-4d80-bba0-69126c1e9ded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Urgent Care & Clinics",
      "poi_type": "Health and Wellness",
      "poi_address": "3220 Parkwood Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-d613-7650-bb5c-ad9ed836959d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-d613-7650-bb5c-ad9ed836959d",
        "storage_key": "property/6767906449167621/019ff6c2-d613-7650-bb5c-ad9ed836959d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.friscoucc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16290564989790602516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-urgent-care--clinics",
      "poi_latitude": "33.1060764",
      "poi_longitude": "-96.814839",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-668-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2Qj44w8TIYRFEXiDoy2E-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_39bb67ca-d151-445a-aab7-4b4cafcb2846",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Heal 360",
      "poi_type": "Health and Wellness",
      "poi_address": "9229 Lebanon Rd, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18431146931389706549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heal-360",
      "poi_latitude": "33.1190669",
      "poi_longitude": "-96.8027187",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW22IRac_TIYRNbGDUHuWyP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_dc24988c-9504-4469-b382-63bcdc41f27e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5049 Preston Rd, Frisco, TX 75034, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-b46b-70b8-8694-a3c53d8e2381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-b46b-70b8-8694-a3c53d8e2381",
        "storage_key": "property/6767906449167621/019fc994-b46b-70b8-8694-a3c53d8e2381.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5049+preston+rd-frisco-tx-75034/id=4786",
      "poi_directions_map_url": "https://maps.google.com/?cid=14978608098114205618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "33.1205932",
      "poi_longitude": "-96.8063099",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-387-9505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-962a-7069-9a63-293779ae0bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-962a-7069-9a63-293779ae0bb0",
        "storage_key": "property/6767906449167621/019fc995-962a-7069-9a63-293779ae0bb0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0vV4lg8TIYRsvfihbS03s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b5cf9ef4-bbe9-4de0-8da3-73ea93bd1b57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Athletic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5828 Nancy Jane Ln, Frisco, TX 75035, USA",
      "poi_short_description": "Family-friendly facility offering a gym, swimming pools (including a lazy river) and waterslides.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-df01-75e4-a1e4-5d3e9c098e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-df01-75e4-a1e4-5d3e9c098e7d",
        "storage_key": "property/6767906449167621/019fc994-df01-75e4-a1e4-5d3e9c098e7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://playfrisco.org/FAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=6774907650033169724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-athletic-center",
      "poi_latitude": "33.1264428",
      "poi_longitude": "-96.8007718",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-292-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYqXYVA8TIYRPLVN2pxOBV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_195b52a0-13d2-4f95-b144-cddf24f9431f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "D1 Training Frisco",
      "poi_type": "Health and Wellness",
      "poi_address": "4944 Preston Rd Ste 252, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-6c80-748d-a088-7fc555e06827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-6c80-748d-a088-7fc555e06827",
        "storage_key": "property/6767906449167621/01a0b66f-6c80-748d-a088-7fc555e06827.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.d1training.com/frisco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7588513238308364072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "d1-training-frisco",
      "poi_latitude": "33.1176158",
      "poi_longitude": "-96.8039952",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-784-8533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvb353Tg9TIYRKB-4ppXQT2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_80b91529-960e-4f4b-a5e7-9d5e314aad1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Legacy Yoga Frisco",
      "poi_type": "Health and Wellness",
      "poi_address": "1377 Legacy Dr #110, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-6c3d-77ed-8eb7-1541f4563a7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-6c3d-77ed-8eb7-1541f4563a7f",
        "storage_key": "property/6767906449167621/01a0b66f-6c3d-77ed-8eb7-1541f4563a7f.webp",
        "width": 819,
        "height": 1024
      },
      "poi_business_url": "https://www.legacyyogafrisco.com/?utm_source=google-business-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2784980007303731978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-yoga-frisco",
      "poi_latitude": "33.0890369",
      "poi_longitude": "-96.8397144",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-697-0565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLyrx_PQ7TIYRClvnqY88piY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_2b143844-c965-482e-a519-d30c99cff996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8745 Gary Burns Dr, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-6d96-7719-82c0-80d42c2b3260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-6d96-7719-82c0-80d42c2b3260",
        "storage_key": "property/6767906449167621/01a0b66f-6d96-7719-82c0-80d42c2b3260.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/frisco-texas-2703/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2703",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559076561028492518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "33.1485481",
      "poi_longitude": "-96.8069381",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-872-2272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTLjnzs8TIYR5qz9qxlfrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_67e59e2b-7315-49cc-933a-301eb65e0ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "J.C. Grant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8220 Wade Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "Neighborhood playground featuring a creek and a playground for toddlers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-3f5f-71ed-b781-f896206e3f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-3f5f-71ed-b781-f896206e3f5c",
        "storage_key": "property/6767906449167621/019ff6a3-3f5f-71ed-b781-f896206e3f5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscotexas.gov/Facilities/Facility/Details/JC-Grant-Park-21",
      "poi_directions_map_url": "https://maps.google.com/?cid=6991951626496640361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jc-grant-park",
      "poi_latitude": "33.1300816",
      "poi_longitude": "-96.812827",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWnyvUI8TIYRaQUMmPVmCGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ec510cfe-3c78-47ae-8b75-d966cb67207c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Commons Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8000 McKinney Rd, Frisco, TX 75034, USA",
      "poi_short_description": "City park offering an extensive playground system, amphitheater, fishing pond & picnic area.",
      "poi_long_description": "City park offering an extensive playground system, amphitheater, fishing pond & picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6bf-5df2-7293-a2af-5a4074385714.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bf-5df2-7293-a2af-5a4074385714",
        "storage_key": "property/6767906449167621/019ff6bf-5df2-7293-a2af-5a4074385714.webp",
        "width": 1280,
        "height": 907
      },
      "poi_business_url": "https://www.friscotexas.gov/facilities/facility/details/Frisco-Commons-104",
      "poi_directions_map_url": "https://maps.google.com/?cid=10196092201259515891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-commons-park",
      "poi_latitude": "33.15584810000001",
      "poi_longitude": "-96.814173",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2v8fhg8TIYR8z80-dXLf40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_886c604c-469a-41af-9de5-3e198b679c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Limestone Quarry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1230 Maltby Dr, Frisco, TX 75035, USA",
      "poi_short_description": "15-acre park with a picnic shelter, playground & public art, plus trails, a pond & basketball court.",
      "poi_long_description": "15-acre park with a picnic shelter, playground & public art, plus trails, a pond & basketball court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-1026-7099-9fe2-6aa8f1cb4fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-1026-7099-9fe2-6aa8f1cb4fe4",
        "storage_key": "property/6767906449167621/019fc995-1026-7099-9fe2-6aa8f1cb4fe4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.friscotexas.gov/facilities/facility/details/limestonequarry-23",
      "poi_directions_map_url": "https://maps.google.com/?cid=16690793264712010307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limestone-quarry-park",
      "poi_latitude": "33.1295058",
      "poi_longitude": "-96.7408204",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeU3nUC4WTIYRQ0qk6gqcoec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_96770550-3936-4546-a03f-a825910af638",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Cottonwood Creek Greenbelt",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3925 Bear Creek Ln, Frisco, TX 75033, USA",
      "poi_short_description": "Linear wetlands park with a fishing pond, walking trails & wildlife observation platforms.",
      "poi_long_description": "Linear wetlands park with a fishing pond, walking trails & wildlife observation platforms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-0d00-726e-8c41-6a433ebfe2f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-0d00-726e-8c41-6a433ebfe2f9",
        "storage_key": "property/6767906449167621/019fc995-0d00-726e-8c41-6a433ebfe2f9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.friscotexas.gov/facilities/facility/details/cottonwood-creek-greenbelt-66",
      "poi_directions_map_url": "https://maps.google.com/?cid=11774639576744004389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cottonwood-creek-greenbelt",
      "poi_latitude": "33.1679239",
      "poi_longitude": "-96.8536348",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3rLq105TIYRJQsVck_sZ6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3389ced8-9fee-429b-9039-4b90e5259f8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Beavers Bend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5011 Legacy Dr, Frisco, TX 75034, USA",
      "poi_short_description": "Neighborhood park with a picnic pavilion, BBQ grill, playground & trails for walking or biking.",
      "poi_long_description": "Neighborhood park with a picnic pavilion, BBQ grill, playground & trails for walking or biking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc994-fe90-71be-86f0-1c65708e55b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-fe90-71be-86f0-1c65708e55b4",
        "storage_key": "property/6767906449167621/019fc994-fe90-71be-86f0-1c65708e55b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscotexas.gov/facilities/facility/details/beaversbendpark-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=208400828733912369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beavers-bend-park",
      "poi_latitude": "33.122019",
      "poi_longitude": "-96.8470627",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxNxnJs7TIYRMfWUF3Nj5AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_bf084c9f-0993-4910-88fb-84ba7272fdc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Big Bluestem Trail at Grand Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5001 Cotton Gin Rd, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-f91b-77b6-8d14-9e940e8c942b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-f91b-77b6-8d14-9e940e8c942b",
        "storage_key": "property/6767906449167621/019ff6a3-f91b-77b6-8d14-9e940e8c942b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscotexas.gov/facilities/facility/details/bigbluestemtrailatgrandpark-123",
      "poi_directions_map_url": "https://maps.google.com/?cid=404371690415917124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-bluestem-trail-at-grand-park",
      "poi_latitude": "33.1457131",
      "poi_longitude": "-96.8435186",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a4-740d-71ae-adee-e038cae98926.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-740d-71ae-adee-e038cae98926",
        "storage_key": "property/6767906449167621/019ff6a4-740d-71ae-adee-e038cae98926.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJa8Bj2eE7TIYRRAh39OidnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_d72ca6bd-8d9d-469b-a568-9eebabe09fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Monarch View Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1900 Koehn Dr, Frisco, TX 75034, USA",
      "poi_short_description": "Relaxed park for families and kids offering playgrounds, swings and slides.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-4047-7788-9e7b-9d249051692e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-4047-7788-9e7b-9d249051692e",
        "storage_key": "property/6767906449167621/019ff6a3-4047-7788-9e7b-9d249051692e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscotexas.gov/Facilities/Facility/Details/Monarch-View-Park-109",
      "poi_directions_map_url": "https://maps.google.com/?cid=1826107142911119037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monarch-view-park",
      "poi_latitude": "33.1990612",
      "poi_longitude": "-96.8745687",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wjf9B85TIYRvU4Fd8WiVxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0e3a5e6a-7a64-4582-ae22-d784779ab57a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Pearson Acres Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7550 Teel Pkwy, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a3-3863-736b-a7a3-eba8ec9fc559.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-3863-736b-a7a3-eba8ec9fc559",
        "storage_key": "property/6767906449167621/019ff6a3-3863-736b-a7a3-eba8ec9fc559.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=677000472528635689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearson-acres-park",
      "poi_latitude": "33.1413586",
      "poi_longitude": "-96.8634281",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCV2buhM7TIYRKUfXxVcwZQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9bac27a2-3a10-4dbd-b74a-2ea213751981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Boyd Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "355 Stonebrook Pkwy, Frisco, TX 75036, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-dff9-7397-a7bc-0e8fe408a065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-dff9-7397-a7bc-0e8fe408a065",
        "storage_key": "property/6767906449167621/019ff6c2-dff9-7397-a7bc-0e8fe408a065.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.friscotexas.gov/Facilities/Facility/Details/Boyd-Park-72",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672877588073806319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boyd-park",
      "poi_latitude": "33.1409539",
      "poi_longitude": "-96.8899404",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9a87-770a-8e88-c5e9be30e015",
        "storage_key": "property/6767906449167621/019fc995-9a87-770a-8e88-c5e9be30e015.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ558g_PU7TIYR7_mVKTdAXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e4a2f9ad-910a-4cbf-adfd-3904c7c7782d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Ironhorse Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Teel Pkwy &, Carraway Dr, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-dc17-75cf-85fa-9bbfa04eb20b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-dc17-75cf-85fa-9bbfa04eb20b",
        "storage_key": "property/6767906449167621/019ff6c2-dc17-75cf-85fa-9bbfa04eb20b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscotexas.gov/facilities/facility/details/Iron-Horse-Trail-and-1135-Wildlife-Prese-89",
      "poi_directions_map_url": "https://maps.google.com/?cid=9117421120101945650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ironhorse-trail",
      "poi_latitude": "33.1163609",
      "poi_longitude": "-96.8736943",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-292-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6a4-740d-71ae-adee-e038cae98926.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-740d-71ae-adee-e038cae98926",
        "storage_key": "property/6767906449167621/019ff6a4-740d-71ae-adee-e038cae98926.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfrVWk87TIYRMhFS2zOWh34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_71603353-61d3-4d58-8696-e3596b7806ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Station",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4141 Frisco Green Ave, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-73d4-71ba-a83c-8969feec35c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-73d4-71ba-a83c-8969feec35c2",
        "storage_key": "property/6767906449167621/01a0b66f-73d4-71ba-a83c-8969feec35c2.webp",
        "width": 947,
        "height": 1280
      },
      "poi_business_url": "http://friscostation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13509850709802864935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-station",
      "poi_latitude": "33.1134831",
      "poi_longitude": "-96.8288669",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-224-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgydw2YY8TIYRJ9FbbqShfLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_75a85f70-3af0-469c-994d-1a223599f64b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Northwest Plano Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "6830 Communications Pkwy, Plano, TX 75024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-51c4-759f-a439-d3ac463051df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-51c4-759f-a439-d3ac463051df",
        "storage_key": "property/6767906449167621/019fc995-51c4-759f-a439-d3ac463051df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/northwestplanoparkandride.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10366841926647898539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-plano-park--ride",
      "poi_latitude": "33.0687872",
      "poi_longitude": "-96.8271549",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9c1a-7614-b4a5-0c65298e6d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9c1a-7614-b4a5-0c65298e6d0f",
        "storage_key": "property/6767906449167621/019fc995-9c1a-7614-b4a5-0c65298e6d0f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbgxVFIjTIYRq2F5cM5r3o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1f0d6af0-cb69-4e05-aad3-ac173c55f0bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Parker Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2600 Archerwood St, Plano, TX 75023, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-4351-74ed-a489-546b96d08a34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-4351-74ed-a489-546b96d08a34",
        "storage_key": "property/6767906449167621/019fc995-4351-74ed-a489-546b96d08a34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17886008671511646165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parker-road-station",
      "poi_latitude": "33.03586180000001",
      "poi_longitude": "-96.7013125",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9c12-76ed-ac5d-752b6ae4be8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9c12-76ed-ac5d-752b6ae4be8c",
        "storage_key": "property/6767906449167621/019fc995-9c12-76ed-ac5d-752b6ae4be8c.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4NUJ6oZTIYR1Q8CYx_eN_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_4dd18094-e3f8-44f8-bb25-23e1953ecf3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "12th Street Silver Line Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1180 12th St, Plano, TX 75074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-7576-77cf-a27c-bf712e36c288.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-7576-77cf-a27c-bf712e36c288",
        "storage_key": "property/6767906449167621/01a0b66f-7576-77cf-a27c-bf712e36c288.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/about/plans-projects-and-initiatives/expansion/silver-line-regional-rail-project",
      "poi_directions_map_url": "https://maps.google.com/?cid=4927780694172873103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "12th-street-silver-line-station",
      "poi_latitude": "33.0153315",
      "poi_longitude": "-96.6985957",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwFC1bsZTIYRj7Ezz27-YkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_748d4745-8dcc-42a3-ba2e-0c51574486e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Shiloh Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Shiloh Rd, Plano, TX 75074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-7837-757d-b4be-973cd2a5f20f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-7837-757d-b4be-973cd2a5f20f",
        "storage_key": "property/6767906449167621/01a0b66f-7837-757d-b4be-973cd2a5f20f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dart.org/about/plans-projects-and-initiatives/expansion/silver-line-regional-rail-project",
      "poi_directions_map_url": "https://maps.google.com/?cid=11206985442079968052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shiloh-road-station",
      "poi_latitude": "33.0108376",
      "poi_longitude": "-96.6648611",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdMHutIZTIYRNIsm5uE1h5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d32e7a41-d02d-4939-af4e-f39b2a0d6652",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-5ccf-7527-9841-ee25be5117a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-5ccf-7527-9841-ee25be5117a9",
        "storage_key": "property/6767906449167621/019fc995-5ccf-7527-9841-ee25be5117a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "29.5",
      "poi_walking_minutes": "10 hours 57 mins",
      "poi_biking_minutes": "2 hours 43 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9c70-7279-be64-f89b7bacb45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9c70-7279-be64-f89b7bacb45b",
        "storage_key": "property/6767906449167621/019fc995-9c70-7279-be64-f89b7bacb45b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_e6165951-1467-4d10-848b-b6c4c9896817",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "DFW Airport Terminal B",
      "poi_type": "Transportation & Transit",
      "poi_address": "Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-77d8-775e-b857-0db80bb76cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-77d8-775e-b857-0db80bb76cc5",
        "storage_key": "property/6767906449167621/01a0b66f-77d8-775e-b857-0db80bb76cc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542362866335770885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-terminal-b",
      "poi_latitude": "32.9062404",
      "poi_longitude": "-97.0412791",
      "poi_miles_from_property": "26.9",
      "poi_walking_minutes": "9 hours 54 mins",
      "poi_biking_minutes": "2 hours 42 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9c1a-7614-b4a5-0c65298e6d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9c1a-7614-b4a5-0c65298e6d0f",
        "storage_key": "property/6767906449167621/019fc995-9c1a-7614-b4a5-0c65298e6d0f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpectJlwqTIYRBWnyYBX-cvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_29040596-da26-4fc9-bb06-c80e1e4ded18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Parking garage",
      "poi_type": "Transportation & Transit",
      "poi_address": "8820 4th St, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-7516-72ae-9534-bc5092c43d08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-7516-72ae-9534-bc5092c43d08",
        "storage_key": "property/6767906449167621/01a0b66f-7516-72ae-9534-bc5092c43d08.webp",
        "width": 936,
        "height": 624
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6557079187900274443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking-garage",
      "poi_latitude": "33.1497974",
      "poi_longitude": "-96.824847",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9c12-76ed-ac5d-752b6ae4be8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9c12-76ed-ac5d-752b6ae4be8c",
        "storage_key": "property/6767906449167621/019fc995-9c12-76ed-ac5d-752b6ae4be8c.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdfZGQA9TIYRCxfnzsds_1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_24cf34b9-f279-41cc-af6e-cbd47d4e4f7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Cozy 1BR apartment in Frisco, Off of Dallas North Tollway. The Star!",
      "poi_type": "Transportation & Transit",
      "poi_address": "Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.vrbo.com/pdp/lo/127026264?MDPCID=VRBO-META.HPA.WEB-ORGANIC.VR",
      "poi_directions_map_url": "https://maps.google.com/?cid=11571519396174796266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cozy-1br-apartment-in-frisco-off-of-dallas-north-tollway-the-star",
      "poi_latitude": "33.1036377",
      "poi_longitude": "-96.8147812",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-8a73-7237-95ba-a968d1264fe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b66f-8a73-7237-95ba-a968d1264fe1",
        "storage_key": "property/6767906449167621/01a0b66f-8a73-7237-95ba-a968d1264fe1.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJh_Bs35I8TIYR6pWKEJVLlqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lodging"
    },
    {
      "id": "custom_d1329e18-16b0-44ae-853f-dd81a55265d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Frisco Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5515 Ohio Dr, Frisco, TX 75035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-5eb8-721e-9227-79a7ef8d8231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-5eb8-721e-9227-79a7ef8d8231",
        "storage_key": "property/6767906449167621/019fc995-5eb8-721e-9227-79a7ef8d8231.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.friscoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10143332820547689825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-independent-school-district",
      "poi_latitude": "33.1246499",
      "poi_longitude": "-96.7966075",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-633-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-95e1-77cc-9067-e12f99565338",
        "storage_key": "property/6767906449167621/019fc995-95e1-77cc-9067-e12f99565338.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9ceq-r49TIYRYV1OZ3VbxIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da4498a1-5bea-4e61-8132-3ae75ebf91df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "George A. Purefoy Municipal Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6101 Frisco Square Blvd, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-68ec-7667-b733-f6e6eb718c40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-68ec-7667-b733-f6e6eb718c40",
        "storage_key": "property/6767906449167621/019fc995-68ec-7667-b733-f6e6eb718c40.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.friscotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3336406272668900799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-a-purefoy-municipal-center",
      "poi_latitude": "33.1501693",
      "poi_longitude": "-96.8347845",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-292-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-9c6b-7221-a819-d2350e99e43e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-9c6b-7221-a819-d2350e99e43e",
        "storage_key": "property/6767906449167621/019fc995-9c6b-7221-a819-d2350e99e43e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9Nq-gc8TIYRv53Q9NNLTS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_20356ad5-6af7-41dd-9858-dd2d22b21b52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "The Star, Home of the Dallas Cowboys",
      "poi_type": "Entertainment",
      "poi_address": "5 Cowboys Way Ste 125, Frisco, TX 75034, USA",
      "poi_short_description": "Event venue including a football field, a store, and a state-of-the-art facility for tours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-6a1e-72cc-bd04-46e6acd73f8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-6a1e-72cc-bd04-46e6acd73f8d",
        "storage_key": "property/6767906449167621/019fc995-6a1e-72cc-bd04-46e6acd73f8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thestarinfrisco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=446211393489763739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-star-home-of-the-dallas-cowboys",
      "poi_latitude": "33.1103715",
      "poi_longitude": "-96.8286446",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5RX_X3s7TIYRm32w8-VCMQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_84aaa939-d517-43ea-b850-56e0eb48ddba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7668 Warren Pkwy, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-65c9-704e-8ea7-eb74ba879018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-65c9-704e-8ea7-eb74ba879018",
        "storage_key": "property/6767906449167621/019fc995-65c9-704e-8ea7-eb74ba879018.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=95255375887639260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "33.1077656",
      "poi_longitude": "-96.8180891",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwzfZJo9TIYR3KK6ekJqUgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6590552a-2d06-447c-8bfa-fafe42cb6dc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Conifer Health Solutions",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7624 Warren Pkwy, Frisco, TX 75034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019ff6c2-e582-71ac-9df8-eb4e86750686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c2-e582-71ac-9df8-eb4e86750686",
        "storage_key": "property/6767906449167621/019ff6c2-e582-71ac-9df8-eb4e86750686.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coniferhealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11881675578823796916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conifer-health-solutions",
      "poi_latitude": "33.110317",
      "poi_longitude": "-96.8187957",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-803-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZKQHow8TIYRtOg5tPww5KQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_af2b7ef4-645c-4669-b224-50bf7c5e34e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "Cencora | 3PL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5025 Plano Pkwy, Carrollton, TX 75010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b66f-78f0-7249-aacc-16e6d4345b3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66f-78f0-7249-aacc-16e6d4345b3c",
        "storage_key": "property/6767906449167621/01a0b66f-78f0-7249-aacc-16e6d4345b3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cencora.com/our-capabilities/logistics-and-warehousing/third-party-logistics",
      "poi_directions_map_url": "https://maps.google.com/?cid=3957595353866848884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cencora--3pl",
      "poi_latitude": "33.05002",
      "poi_longitude": "-96.8721558",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-285-7481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZzvE6TglTIYRdEr4jwE07DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_e68c7f47-5acb-44f8-859a-4dbfd0bea8f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "poi_name": "PGA of America Frisco Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1916 PGA Pkwy, Frisco, TX 75033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0100a-7543-74f8-a408-71e8c08a206c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-7543-74f8-a408-71e8c08a206c",
        "storage_key": "property/6767906449167621/01a0100a-7543-74f8-a408-71e8c08a206c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304696643775632767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pga-of-america-frisco-headquarters",
      "poi_latitude": "33.2141253",
      "poi_longitude": "-96.8597638",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-474-2776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-961f-7579-8f15-ebcd2adf3931",
        "storage_key": "property/6767906449167621/019fc995-961f-7579-8f15-ebcd2adf3931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5e5hd4A_TIYRfxXkV682GxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3e1e952e260848aff0adaf5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b9d670c872fe7d91ab919a22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0088fe5f8ae3c3455871b04a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c95c1a7696e55d8fd6c9150a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d2f4ef5ef0e786c4d9b8cd7a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7a257ac8c9baba25e11cb2ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_50bc793ca0d9b8d95db9612f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "rating": "5",
      "name": "Maria Segnini",
      "text": "My husband and I have been living at Wade crossing for almost 5 years now, and honestly we’ve had such a great experience here. It’s a very peaceful and family-friendly place, and anytime there’s been an issue or something we needed, it always gets handled quickly.\n\nWe especially want to thank John for always being so kind and helpful to us throughout all these years. He’s always willing to help, answer questions, or guide you with anything you need. You can tell he genuinely cares about the residents and wants everyone to feel comfortable here.\n\nWe’re really grateful for the experience we’ve had living here and definitely recommend this community. If you get the chance to work with John, you’ll be in very good hands!",
      "date": "2026-05-13",
      "title": "false"
    },
    {
      "id": "ec_6c5717d44fb28f92e5e69cad",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "rating": "5",
      "name": "Victor Lucena",
      "text": "WadeCrossing has been a really great place to live these past few years. The community is peaceful, well maintained, and overall has always felt very comfortable and welcoming.\nOne of the people who has made our experience here even better has been John. He has always been very respectful, helpful, and easy to talk to. You can tell he genuinely cares about the residents and wants everyone to have a good experience living here.\n\nBecause of that, I honestly think he would make a great main manager for the complex. He already does such a good job helping residents and creating a positive environment in the community.\n\nVery thankful for the experience we’ve had living here and definitely recommend this place to others.",
      "date": "2026-05-13",
      "title": "false"
    },
    {
      "id": "ec_15f10e531aa36b2b93ecaa71",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "rating": "5",
      "name": "Howard Hubbard",
      "text": "Exceptional Service from John, Assistant Manager\n\nI recently visited Wade Crossing Apartment Homes and had the pleasure of working with John, the assistant manager. He went above and beyond to make my experience positive. John was incredibly friendly and welcoming from the moment I arrived. What stood out most was his knowledge; he was able to answer every question I had about the community, floor plans, and amenities with clarity and patience. His helpfulness made the entire process smooth and stress-free. It is rare to find such dedication and expertise combined with genuine warmth. I highly recommend John and Wade Crossing Apartment Homes to anyone looking for a great living experience.",
      "date": "2026-05-16",
      "title": "false"
    },
    {
      "id": "ec_c9e2d3730a9b8d92568ce63d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "rating": "5",
      "name": "Sarah Guillotte",
      "text": "I simply cannot be more grateful than I am for Abraham. He’s so professional and kind and has always been quick to respond to any work order that was assigned to him. He’s conscientious and mindful and the management is really lucky to have such a hard-working young man. These wonderful maintenance men are such a powerful chain and maintaining this property. I’m sure it can’t be easy and Abraham is always quick to answer even if it’s just with a smile.",
      "date": "2026-04-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a50c663a2d1a31161832ca75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "A2 - 1 bed, 1 bath, 769 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-58b2-7120-816a-6ccbe3cdd8e3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b675-58b2-7120-816a-6ccbe3cdd8e3",
        "storage_key": "property/6767906449167621/01a0b675-58b2-7120-816a-6ccbe3cdd8e3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2 | Sunnyland",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QfyVE2ihtLD"
    },
    {
      "id": "ec_aae7653dcd85a38472e321f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "B3 - 2 bed, 2 bath, 1,137 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167621/01a0b675-57ee-74ee-afcb-3d96114ed2c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b675-57ee-74ee-afcb-3d96114ed2c9",
        "storage_key": "property/6767906449167621/01a0b675-57ee-74ee-afcb-3d96114ed2c9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B3 | Firefly",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=B53MwHvzy4L"
    }
  ],
  "faqs": [
    {
      "id": "custom_f24d2286-9878-4dd2-94e0-bfbdd2c4a512",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_1086e778-845f-4102-b018-93ce2f7cb468",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_22e54a9a-5be1-4744-9f8f-ad9b85ff287d",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_96900970-32c6-4bf7-9290-740bee0ce51c",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c87749a9-8407-4ba6-bfc7-50efda21fbea",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_48f3fb09-4451-4fb3-855a-c21e11d637d7",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d2f1774f-2f7e-4e40-94f1-e3a557fbafe5",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_fb4bf6aa-4b95-4290-a3e6-08ef861c7d84",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c0dc5925-47bf-4fd4-9e46-7cec81e44e01",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_014e3752-e233-4f04-b42b-f83d75a91a17",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ea8a47e4-90db-4b2e-9426-a7cf5d594f42",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4388f813-dbc6-4ffb-82ba-40fb77743333",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a2e34e2d-e830-4eff-9af4-a6fbc9f76672",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_18a25731-c89c-45bd-996c-9346a3a02ff6",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports. Please <a href=\"/contact-us\">contact the office</a> for our most current carport availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_43b747f7-c8f1-4989-8401-16991e35593d",
      "question": "Is a washer and dryer included in the apartment?",
      "answer": "No, but we do provide washer/dryer hook-ups as well as a laundry facility within our community.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d025a75e-294e-46e6-bab2-e120660c2520",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_97a57b1e-c7e0-4ffc-8487-5a77811093c3",
      "question": "Can I reserve the Clubhouse for a private event?",
      "answer": "Yes! We allow residents to rent the clubhouse for private events after business hours. An employee from our community is required to remain onsite during the time of the event. Please <a href=\"/contact-us\">contact our office</a> for details and any questions you might have, including availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_f1a242d4-31b4-4635-aa61-be60316aff2c",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_b9bde766-d55a-42f0-8828-e99f5d7ace77",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4d0b-734b-b833-9b8a161558b7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Wade Crossing Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621"
    },
    {
      "lead_collector_id": "01a0c9ac-4d8c-768d-89e6-2f00a010ab78",
      "lead_source": "LANDING_PAGE",
      "name": "Wade Crossing Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-frisco-tx",
      "search_query": "apartments with in unit laundry Frisco TX",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Frisco, TX",
      "h2_subtitle": "Wade Crossing offers convenient in-unit laundry. Experience ultimate convenience in the heart of Frisco with our modern amenities.",
      "page_copy": "Welcome to Wade Crossing Apartment Homes, where you can find ideal living spaces featuring in-unit laundry in Frisco, TX. Our community offers one, two, and three-bedroom floor plans designed with comfort and convenience in mind. Enjoy modern features like high-speed internet access, granite countertops, and a personal laundry setup that simplifies your daily routine.\n\nLocated in the vibrant city of Frisco, TX, Wade Crossing ensures easy access to various local attractions and essentials. Besides the luxurious in-unit laundry, residents can appreciate a security system, ceiling fans, and a dishwasher for effortless living. Schedule a tour today to explore why Wade Crossing is the perfect place for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Frisco, TX",
      "seo_description": "Discover apartments with in-unit laundry at Wade Crossing, Frisco. Enjoy ultimate convenience and modern amenities in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "frisco-apartments-with-air-conditioning",
      "search_query": "Frisco apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Frisco Apartments with Air Conditioning",
      "h2_subtitle": "Wade Crossing offers air-conditioned comfort. Enjoy modern amenities in Frisco, TX, in our cool and comfortable apartments.",
      "page_copy": "Discover the comfort of Wade Crossing Apartment Homes, where providing Frisco apartments with air conditioning is just one of our many amenities. Our thoughtfully designed one, two, and three-bedroom apartments are equipped with features like ceiling fans and high-speed internet access, ensuring you stay cool and connected.\n\nSituated in the bustling city of Frisco, TX, Wade Crossing offers not only air-conditioned living spaces but also easy access to local shops, dining, and entertainment. With added amenities such as granite countertops and a security system, our community blends convenience with comfort. Visit Wade Crossing and find your air-conditioned oasis today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Frisco, TX Apartments with Air Conditioning",
      "seo_description": "Stay cool in Frisco, TX with air-conditioned apartments at Wade Crossing. Enjoy modern amenities and a lively community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartment-with-dishwasher-frisco-75035",
      "search_query": "apartment with dishwasher Frisco 75035",
      "category": "Amenity",
      "h1_title": "Apartment with Dishwasher in Frisco 75035",
      "h2_subtitle": "Wade Crossing offers apartments with dishwashers. Experience easy living in Frisco, 75035, with our modern kitchens and amenities.",
      "page_copy": "Find your perfect home at Wade Crossing Apartment Homes, where each apartment comes equipped with a dishwasher in Frisco, 75035. Our community offers a range of spacious one, two, and three-bedroom floor plans that provide everything you need for convenient living. Enjoy modern kitchen amenities alongside high-speed internet and granite countertops.\n\nLocated in the heart of Frisco, TX, Wade Crossing blends serene community spaces with proximity to city attractions, making it an ideal place to settle down. In addition to having a dishwasher, our apartments feature ceiling fans and a security system to ensure a comfortable and secure environment. Discover why Wade Crossing is the pinnacle of apartment living by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher-equipped Apartments in Frisco 75035",
      "seo_description": "Explore Wade Crossing for apartments with dishwashers in Frisco 75035. Enjoy modern kitchen amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "frisco-tx-apartments-with-pool",
      "search_query": "Frisco TX apartments with a pool",
      "category": "Amenity",
      "h1_title": "Frisco TX Apartments with a Pool",
      "h2_subtitle": "Relax at Wade Crossing's stunning pool. Dive into luxury living in Frisco, TX, with our inviting apartment community amenities.",
      "page_copy": "Come home to Wade Crossing Apartment Homes, where you'll find Frisco, TX apartments with a pool perfect for relaxing. Our one, two, and three-bedroom floor plans are complemented by a refreshing pool area that offers a perfect escape on hot Texas days. Experience thoughtfully designed living spaces with high-speed internet access and modern finishes.\n\nLocated in vibrant Frisco, our community not only boasts a delightful pool but also features amenities like granite countertops and ceiling fans, enhancing your living experience. Embrace the close-knit community vibe and explore the excitement of Frisco with ease from your new home. Schedule a visit today to see firsthand why Wade Crossing should be your next living choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Frisco, TX Apartments with Pool Access",
      "seo_description": "Discover Wade Crossing in Frisco, TX, featuring apartments with a refreshing pool. Enjoy luxury living and top-notch amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-fitness-center-collin-county",
      "search_query": "luxury apartments with fitness center Collin County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Experience upscale living with a fitness center. Wade Crossing in Collin County offers luxurious apartment homes with premium amenities.",
      "page_copy": "Discover the pinnacle of upscale living at Wade Crossing Apartment Homes, where luxury apartments with a fitness center await you in Collin County. Our community is designed to cater to your lifestyle with spacious one, two, and three-bedroom floor plans, all featuring elegant finishes like granite countertops and efficient high-speed internet access.\n\nNestled in dynamic Frisco, TX, Wade Crossing goes beyond just fitness amenities. Whether you’re enjoying the cool comfort of air-conditioned interiors or the convenience of our in-unit dishwashers, our apartments offer everything you need for a relaxed, vibrant lifestyle. Visit us today and experience why our luxury community sets the standard in Collin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments in Collin County with Gym",
      "seo_description": "Explore luxury living at Wade Crossing in Collin County, featuring a fitness center and modern amenities for the ultimate apartment experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-frisco-tx",
      "search_query": "one bedroom apartments frisco tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Frisco, TX",
      "h2_subtitle": "Find the ideal one-bedroom apartment at Wade Crossing. Discover spacious living options in Frisco, TX with modern amenities.",
      "page_copy": "Welcome to Wade Crossing Apartment Homes, where we offer exceptional one-bedroom apartments in Frisco, TX. Our well-designed floor plans provide ample living space and comfortable features, including high-speed internet access and ceiling fans, ensuring an enjoyable living environment.\n\nLocated in the heart of Frisco, our community not only delivers stylish interiors but also boasts convenient amenities like granite countertops and security systems. Wade Crossing is ideally situated for easy access to local attractions, making your living experience as vibrant as the city itself. Contact us today to learn more about securing your one-bedroom retreat in Frisco, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Frisco, TX",
      "seo_description": "Explore one-bedroom apartments at Wade Crossing in Frisco, TX. Enjoy modern features and community amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-collin-county",
      "search_query": "two bedroom apartments near collin county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments near Collin County",
      "h2_subtitle": "Explore spacious two-bedroom layouts at Wade Crossing. Conveniently located near Collin County, offering comfortable living spaces.",
      "page_copy": "Discover Wade Crossing Apartment Homes, the perfect destination for those seeking two-bedroom apartments near Collin County. Our diverse floor plans provide ample space and comfort, complemented by stylish finishes like granite countertops and efficient high-speed internet access.\n\nLocated in vibrant Frisco, TX, our community offers more than just beautiful interiors. Residents enjoy amenities like a security system, a refreshing pool, and spacious community areas. Whether you need room for a home office, guests, or extra storage, our two-bedroom apartments provide the ideal living solution close to the best that Collin County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments near Collin County",
      "seo_description": "Find two-bedroom apartments at Wade Crossing, perfectly located near Collin County. Enjoy modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-75035",
      "search_query": "three bedroom apartments 75035",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 75035",
      "h2_subtitle": "Discover spacious three-bedroom apartments at Wade Crossing, located in the 75035 area, offering comfort and modern amenities.",
      "page_copy": "Searching for three-bedroom apartments in the 75035 area? Wade Crossing Apartment Homes brings you the ideal blend of space and style in Frisco, TX. Our expansive layouts are perfect for anyone who needs extra room, featuring modern finishes including granite countertops and high-speed internet access.\n\nLocated in the lively Frisco community, residents enjoy easy access to local conveniences and a host of community amenities such as ceiling fans, a sophisticated security system, and communal spaces ideal for relaxation and socializing. Experience the best of large-scale living at Wade Crossing where comfort meets convenience. Schedule a tour to see these beautiful homes in person.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Frisco 75035",
      "seo_description": "Explore three-bedroom apartments at Wade Crossing in the 75035 area. Discover spacious living with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-otis-spears-elementary-school",
      "search_query": "apartments near Otis Spears Elementary School Frisco",
      "category": "School",
      "h1_title": "Apartments near Otis Spears Elementary School",
      "h2_subtitle": "Find comfortable living at Wade Crossing, located near Otis Spears Elementary in Frisco.",
      "page_copy": "Wade Crossing Apartment Homes offers apartments near Otis Spears Elementary School in Frisco. With our prime location, commuting is a breeze, giving you more time for what matters to you.\n\nOur community presents a range of inviting floor plans, with amenities that include a dishwasher, granite countertops, and access to high-speed internet, making daily life easier. Situated in the heart of Frisco, our apartments offer accessibility and convenience, with thoughtful features and community spaces that enhance your living experience.. Discover the ideal balance of comfort and practicality at Wade Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Otis Spears Elementary School",
      "seo_description": "Discover apartments near Otis Spears Elementary School at Wade Crossing in Frisco, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "wade-crossing-near-shawnee-trail-elementary",
      "search_query": "Wade Crossing apartments by Shawnee Trail Elementary",
      "category": "School",
      "h1_title": "Wade Crossing Apartments by Shawnee Trail",
      "h2_subtitle": "Live close to Shawnee Trail Elementary at Wade Crossing, a community-rich home in Frisco.",
      "page_copy": "Located conveniently in Frisco, Wade Crossing Apartment Homes offers apartments by Shawnee Trail Elementary. Our spacious apartment homes provide comfort and convenience just minutes from the school.\n\nWade Crossing boasts a wealth of amenities, including a security system, ceiling fans, and granite countertops, making everyday living both enjoyable and easy. The community spaces and high-speed internet access support a modern lifestyle while keeping you connected. Discover a welcoming environment at Wade Crossing, where convenience and lifestyle meet harmoniously.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wade Crossing by Shawnee Trail Elementary",
      "seo_description": "Explore Wade Crossing Apartments, located near Shawnee Trail Elementary in Frisco. Comfortable living with modern amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "rental-apartments-near-claude-curtsinger-elementary",
      "search_query": "rental apartments close to Claude Curtsinger Elementary School",
      "category": "School",
      "h1_title": "Rental Apartments Near Claude Curtsinger Elementary",
      "h2_subtitle": "Conveniently located rental apartments close to Claude Curtsinger Elementary in Frisco.",
      "page_copy": "Wade Crossing Apartment Homes provides excellent rental options close to Claude Curtsinger Elementary School in Frisco. Our community offers easy access to this well-regarded school, making morning routines simple and efficient.\n\nEnjoy living in spacious apartment homes that feature amenities such as high-speed internet and a modern security system, enhancing both convenience and peace of mind. Granite countertops and a dishwasher add style and functionality to your home. Experience a welcoming community at Wade Crossing, where location and lifestyle come together seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Apts Near Claude Curtsinger Elementary",
      "seo_description": "Discover rental apartments near Claude Curtsinger Elementary School at Wade Crossing in Frisco. Convenient, comfortable living in Frisco.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "living-near-kenneth-rex-talley-elementary",
      "search_query": "living near Kenneth Rex Talley Elementary School Frisco TX",
      "category": "School",
      "h1_title": "Living Near Kenneth Rex Talley Elementary",
      "h2_subtitle": "Experience comfortable living near Kenneth Rex Talley Elementary in Frisco, TX.",
      "page_copy": "Wade Crossing Apartment Homes offers a thriving community near Kenneth Rex Talley Elementary School in Frisco, TX. Our location keeps daily commutes efficient, giving you more time for what you enjoy. \n\nOur diverse floor plans include high-speed internet access and ceiling fans for comfort and connectivity. Granite countertops and modern appliances elevate daily living. At Wade Crossing, enjoy a welcoming community atmosphere that balances convenience with quality of life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Kenneth Rex Talley Elementary",
      "seo_description": "Choose Wade Crossing for living near Kenneth Rex Talley Elementary in Frisco, TX. Enjoy comfortable apartments and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-adelle-clark-middle-school",
      "search_query": "apartments close to Adelle R. Clark Middle School 75035",
      "category": "School",
      "h1_title": "Apartments Close to Adelle R. Clark Middle School",
      "h2_subtitle": "Find ideal apartments close to Adelle R. Clark Middle School in the 75035 area. Convenience and comfort in Frisco.",
      "page_copy": "Wade Crossing Apartment Homes offers apartments close to Adelle R. Clark Middle School in the 75035 zip code. Our location ensures that getting to school is as easy and quick as a short walk or drive.\n\nExperience the best of Frisco with our well-appointed homes, featuring amenities like a security system for peace of mind and high-speed internet access to keep you connected. Spacious layouts, ceiling fans, and granite countertops offer style and practicality. Discover a welcoming community at Wade Crossing, where residents thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Adelle R. Clark Middle School 75035",
      "seo_description": "Discover Wade Crossing Apartments near Adelle R. Clark Middle School in 75035, offering comfortable living in Frisco.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-lebanon-trail-high-school",
      "search_query": "apartments near Lebanon Trail High School Frisco",
      "category": "School",
      "h1_title": "Apartments Near Lebanon Trail High School",
      "h2_subtitle": "Explore convenient living in apartments near Lebanon Trail High School in Frisco.",
      "page_copy": "Wade Crossing Apartment Homes offers exceptional living options for those seeking apartments near Lebanon Trail High School in Frisco. Enjoy the ease of a nearby school commute, giving students more time for academics and activities.\n\nOur community features one-, two-, and three-bedroom layouts designed with comfort in mind, including high-speed internet access and security systems. Granite countertops and dishwashers enhance everyday convenience, making home life even more enjoyable. At Wade Crossing, you’ll find a welcoming environment where education and community living meet with ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Lebanon Trail High School Frisco",
      "seo_description": "Discover Wade Crossing Apartments near Lebanon Trail High School in Frisco. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "wade-crossing-near-centennial-high-school",
      "search_query": "Wade Crossing Apartment Homes by Centennial High School",
      "category": "School",
      "h1_title": "Wade Crossing by Centennial High School",
      "h2_subtitle": "Discover Wade Crossing Apartment Homes situated conveniently by Centennial High School in Frisco.",
      "page_copy": "Situated in a prime Frisco location, Wade Crossing Apartment Homes offers unparalleled access to Centennial High School. Our community provides a convenient, comfortable home base in Frisco.\n\nWith beautifully designed floor plans, ranging from one to three bedrooms, our apartments include modern amenities such as a security system, high-speed internet access, and stylish granite countertops. Relish in the convenience of living just moments from Centennial High School, while enjoying the relaxed and friendly community spaces at Wade Crossing Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wade Crossing Near Centennial High School",
      "seo_description": "Wade Crossing Apartment Homes near Centennial High School offers comfortable living with modern amenities in Frisco.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-collin-college-frisco-campus",
      "search_query": "apartments near Collin College Frisco Campus",
      "category": "School",
      "h1_title": "Apartments Near Collin College Frisco Campus",
      "h2_subtitle": "Find convenient living with apartments near Collin College Frisco Campus. Ideal for students and professionals in Frisco.",
      "page_copy": "Wade Crossing Apartment Homes provides the perfect location for students and professionals seeking apartments near Collin College Frisco Campus. Enjoy the easy commute, making it simple to balance academic and social life.\n\nOur community features a range of one to three-bedroom floor plans, characterized by modern finishes such as granite countertops, high-speed internet access, and ceiling fans. With enhanced security systems and a welcoming community environment, Wade Crossing ensures a conducive living experience close to Collin College, blending comfort and convenience seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Collin College Frisco Campus",
      "seo_description": "Discover Wade Crossing Apartments near Collin College Frisco Campus, offering convenience for students and professionals in Frisco.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-career-tech-center-frisco",
      "search_query": "apartments close to Career and Technical Education Center Frisco",
      "category": "School",
      "h1_title": "Apartments Close to Career Tech Center Frisco",
      "h2_subtitle": "Discover the convenience of living in apartments close to the Career and Technical Education Center in Frisco. Perfect for students and instructors alike.",
      "page_copy": "Wade Crossing Apartment Homes is an excellent choice for those seeking apartments close to the Career and Technical Education Center in Frisco. Our community caters to both students and educators, providing a comfortable and efficient living environment.\n\nEnjoy our spacious one, two, and three-bedroom apartment floor plans, all furnished with high-speed internet access, granite countertops, and ceiling fans, ensuring you have a conducive setting for studying or relaxing. The proximity to the education center enhances your daily routine, while our community amenities offer you the perfect balance of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Career Tech Center Frisco",
      "seo_description": "Find apartments near the Career and Technical Education Center in Frisco at Wade Crossing. Ideal for students and educators, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-texas-health-hospital-frisco",
      "search_query": "apartments near Texas Health Hospital Frisco",
      "category": "Hospital",
      "h1_title": "Apartments Near Texas Health Hospital Frisco",
      "h2_subtitle": "Experience convenient living in apartments near Texas Health Hospital in Frisco. Ideal for anyone who wants to live close to the hospital.",
      "page_copy": "Wade Crossing Apartment Homes is the perfect location for those seeking apartments near Texas Health Hospital Frisco. Our community is ideal for anyone looking for comfort and accessibility near the hospital.\n\nChoose from our selection of thoughtfully designed one, two, and three-bedroom floor plans, each offering modern comforts like high-speed internet access, granite countertops, and a security system. With the hospital just moments away, you'll appreciate the ease of access for work and leisure, while enjoying the relaxed vibe of our welcoming community spaces at Wade Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Texas Health Hospital Frisco",
      "seo_description": "Live at Wade Crossing Apartments near Texas Health Hospital Frisco. Ideal for healthcare workers, offering modern amenities and close proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-baylor-scott-white-frisco",
      "search_query": "apartments close to Baylor Scott & White Medical Center - Frisco TX",
      "category": "Hospital",
      "h1_title": "Apts Close to Baylor Scott & White Frisco",
      "h2_subtitle": "Find the ideal home at apartments close to Baylor Scott & White Medical Center in Frisco. Perfect for medical staff and patients.",
      "page_copy": "Wade Crossing Apartment Homes offers an ideal location for those seeking apartments close to Baylor Scott & White Medical Center in Frisco, TX. Whether you're a healthcare professional, patient, or visitor, our community provides the accessibility and comfort you desire.\n\nOur one, two, and three-bedroom floor plans feature modern amenities such as high-speed internet, granite countertops, and ceiling fans. Situated just minutes from Baylor Scott & White, Wade Crossing ensures that you're never far from where you need to be, all while enjoying the comforts and community of a top-tier living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Baylor Scott & White Frisco TX",
      "seo_description": "Discover apartments near Baylor Scott & White Medical Center in Frisco at Wade Crossing. Perfect for professionals seeking comfort close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-monarch-view-park-frisco",
      "search_query": "apartments near Monarch View Park Frisco",
      "category": "Park",
      "h1_title": "Apts Near Monarch View Park Frisco",
      "h2_subtitle": "Explore apartments near Monarch View Park in Frisco. Perfect for nature lovers and active lifestyle seekers.",
      "page_copy": "Wade Crossing Apartment Homes is your gateway to natural beauty with apartments near Monarch View Park in Frisco. Enjoy the serenity and outdoor activities that the park offers, just steps from your home.\n\nDiscover our range of one, two, and three-bedroom floor plans, thoughtfully designed with features like high-speed internet, granite countertops, and dishwashers. Living near Monarch View Park means you'll have easy access to trails, green spaces, and community events, while still enjoying the modern amenities and comfortable living environment at Wade Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Monarch View Park Frisco",
      "seo_description": "Live at Wade Crossing Apartments near Monarch View Park in Frisco. Ideal for nature enthusiasts seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-close-to-pearson-acres-park-frisco",
      "search_query": "apartments close to Pearson Acres Park Collin County",
      "category": "Park",
      "h1_title": "Apts Close to Pearson Acres Park Frisco",
      "h2_subtitle": "Discover apartments close to Pearson Acres Park in Frisco. Ideal for outdoor enthusiasts in Collin County.",
      "page_copy": "At Wade Crossing Apartment Homes, discover the convenience of living in apartments close to Pearson Acres Park, nestled in the heart of Collin County. Perfect for those who love being close to nature, our community offers easy access to the park's wide-open spaces and recreational amenities.\n\nChoose from our selection of one-, two-, and three-bedroom floor plans, each thoughtfully designed with amenities like a dishwasher, high-speed internet, and ceiling fans. With Pearson Acres Park just a short walk away, enjoy the perfect blend of comfort and outdoor adventure at Wade Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Pearson Acres Park Frisco",
      "seo_description": "Live at Wade Crossing Apartments, close to Pearson Acres Park in Frisco. Perfect for outdoor enthusiasts in Collin County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "rental-homes-by-boyd-park-frisco",
      "search_query": "rental homes by Boyd Park 75035",
      "category": "Park",
      "h1_title": "Rental Homes by Boyd Park Frisco 75035",
      "h2_subtitle": "Experience rental homes by Boyd Park in Frisco, 75035. Perfect for those seeking community and accessibility.",
      "page_copy": "Discover the charm of living in rental homes by Boyd Park at Wade Crossing Apartment Homes, located in the vibrant neighborhood of Frisco, 75035. Whether you enjoy morning jogs or want a peaceful place to relax, Boyd Park offers the perfect natural backdrop.\n\nOur selection of spacious one, two, and three-bedroom homes are crafted with modern comforts and conveniences such as granite countertops, a security system, and high-speed internet access. Enjoy living close to Boyd Park and explore the best of nature and community right outside your door at Wade Crossing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes by Boyd Park Frisco 75035",
      "seo_description": "Explore rental homes by Boyd Park in Frisco's 75035 area at Wade Crossing. Ideal for those seeking a community-oriented lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167621",
      "source": "custom",
      "page_item_url": "apartments-near-dfw-airport-frisco",
      "search_query": "apartments near Dallas Fort Worth International Airport",
      "category": "Transit",
      "h1_title": "Apts Near Dallas Fort Worth Airport",
      "h2_subtitle": "Find modern apartments near Dallas Fort Worth International Airport. Ideal for frequent travelers and busy professionals.",
      "page_copy": "Wade Crossing Apartment Homes offers modern living just a short drive from Dallas Fort Worth International Airport. Our community is an ideal choice for those who value accessibility and convenience without compromising on comfort. \n\nChoose from our diverse selection of one, two, and three-bedroom floor plans, featuring upscale amenities like granite countertops and high-speed internet access. Stay connected with an easy commute and enjoy the peaceful surroundings of Frisco when you return home. Wade Crossing provides the perfect balance of quiet suburban living with quick access to the bustling hub of DFW Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex swimming pool and clubhouse area.",
        "public_id": "019fc98e-1f33-7773-9afa-7df9112df0e5",
        "storage_key": "property/6767906449167621/019fc98e-1f33-7773-9afa-7df9112df0e5.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Dallas Fort Worth Airport",
      "seo_description": "Wade Crossing offers apartments near Dallas Fort Worth International Airport, perfect for travelers seeking convenience and comfort in Frisco.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701935225"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5BLKVG9P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 4"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/a2f154a1-c0e7-4c61-8932-110a19bb7c71/app.js?nocache=1&gaTracking=G-FPR8HLK35W&buttonbgcolor=d19000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "972-975-5067"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBXMkg3dGVhaVRNN3ZZemw4eXFXRkE9PSIsInZhbHVlIjoid053RnFaR2lBSFpQSlF0US9WckFVQT09IiwibWFjIjoiOGFjMDFiNDJiYzcwMTY1YjNhZjgwYWVjZjk3OTU0MjNjM2ZkYzNlYWFmNzBhNzdmODZiZTY0Mzk0NzJmNDIxZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701935225",
  "custom_google_gtm_id": "GTM-5BLKVG9P",
  "custom_rollout_phase": "Batch 4",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/a2f154a1-c0e7-4c61-8932-110a19bb7c71/app.js?nocache=1&gaTracking=G-FPR8HLK35W&buttonbgcolor=d19000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "972-975-5067",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBXMkg3dGVhaVRNN3ZZemw4eXFXRkE9PSIsInZhbHVlIjoid053RnFaR2lBSFpQSlF0US9WckFVQT09IiwibWFjIjoiOGFjMDFiNDJiYzcwMTY1YjNhZjgwYWVjZjk3OTU0MjNjM2ZkYzNlYWFmNzBhNzdmODZiZTY0Mzk0NzJmNDIxZSJ9",
  "custom_audioeye_site_id": "18dcbdcb-ca77-4faa-890d-3d61e49f43c1",
  "custom_audioeye_site_hash": "6a1631384ed0db25b7a6e0e172b2593f"
};

export const generatedAt = '2026-11-03T22:58:20.665Z';
